/* Selection and pin indicators share one accent, including host theme changes. */
:root { --arkme-directory-accent: #9eadff; }

[data-arkme-workspace] {
  --arkme-line: #e7e7e9;
  --arkme-muted: #8e9199;
  --arkme-soft: #f6f6f7;
  --arkme-focus: #cbd5ff;
  color: #171923;
  font-family: "SF Pro Text", "SF Pro Display", -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", "Microsoft YaHei", sans-serif;
  font-synthesis: none;
}

[data-arkme-workspace], [data-arkme-workspace] * { box-sizing: border-box; }
/* Shared DSH selectors and topic-footer controls own their styles in both the
   workspace and body portal. Do not strip their native fill/border/typography. */
[data-arkme-workspace] button:not([data-arkme-conversation-selector], .arkme-self-topic-create-button, .arkme-dsh-view-options-button), [data-arkme-workspace] input, [data-arkme-workspace] textarea { font: inherit; }
[data-arkme-workspace] button:not([data-arkme-conversation-selector], .arkme-self-topic-create-button, .arkme-dsh-view-options-button) { border: 0; background: none; color: inherit; cursor: pointer; }
[data-arkme-workspace] [data-arkme-theme-image="dark"] { display: none !important; }

.arkme-redesign-root {
  --arkme-native-titlebar: 0px;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}
.arkme-native-desktop .arkme-redesign-root { --arkme-native-titlebar: 50px; }
.arkme-native-desktop .arkme-redesign-root::before { content: ""; position: absolute; z-index: 30; top: 49px; left: 0; right: 0; height: 1px; background: #e8e8ea; pointer-events: none; }
.arkme-native-desktop [data-arkme-owned="persistent-sidebar"] > [data-arkme-owned="product-navigation"] { padding-top: 28px !important; }

.arkme-redesign-rail {
  position: absolute;
  z-index: 8;
  top: calc(26px + var(--arkme-native-titlebar));
  bottom: 22px;
  left: 24px;
  width: var(--arkme-navigation-width);
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e4e7;
  border-radius: 22px;
  background: #fbfbfc;
  box-shadow: 0 16px 38px rgba(30, 32, 38, .055);
}

.arkme-redesign-rail-primary { display: flex; flex-direction: column; gap: 5px; }
.arkme-redesign-rail-primary button {
  position: relative;
  min-height: 57px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 15px;
  color: #3e4149;
  transition: background .18s ease, color .18s ease;
}
.arkme-redesign-rail-primary button span { font-size: 11px; font-weight: 400; letter-spacing: .01em; }
.arkme-redesign-rail-primary button:not([data-arkme-feedback]):hover { background: #f4f4f5; }
.arkme-redesign-rail-primary button.is-active { color: #151722; background: #f1f2f6; }
/* One selection marker for both navigation columns. It overlays the row's
   inset without consuming space or changing the avatar anchor when selected. */
[data-arkme-selection-marker],
.arkme-redesign-rail-primary button.is-active::before,
[aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] button[role="treeitem"][aria-selected="true"]::before {
  content: "";
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 33px;
  border-radius: 2px;
  background: var(--arkme-directory-accent);
}
.arkme-redesign-rail-primary button.is-active::before { left: -8px; }
.arkme-redesign-rail-footer {
  position: relative;
  margin-top: auto;
  padding-top: 0;
  display: grid;
  justify-items: center;
  gap: 7px;
  border-top: 0 solid #ededee;
}
.arkme-redesign-rail-footer > button {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  color: #4b4f58;
}
.arkme-redesign-rail-footer > button:not([data-arkme-feedback]):hover, .arkme-redesign-rail-footer > button.is-active { background: #f1f2f5; }
.arkme-redesign-rail-footer:empty { display: none; }
.arkme-conversation-input-card { display: contents; }
body:is([data-ds-skin='qq2006'], [data-arkme-skin='qq2006']) [data-arkme-owned='product-surface']
  .arkme-conversation-input-card.arkme-conversation-input-card.arkme-conversation-tools {
  display: flex !important;
}
.arkme-redesign-profile { position: relative; padding: 0; }
.arkme-redesign-profile-popover { position: fixed; z-index: 10000; left: calc(var(--arkme-navigation-width) - 8px); bottom: 14px; width: 264px; padding: 10px; border: 1px solid rgba(216,217,221,.9); border-radius: 18px; background: rgba(255,255,255,.96); box-shadow: 0 20px 50px rgba(26,28,35,.15), 0 2px 8px rgba(26,28,35,.05); backdrop-filter: blur(20px); }
.arkme-redesign-profile-head { padding: 9px 9px 13px; display: flex; align-items: center; gap: 11px; }
button.arkme-redesign-profile-head { width: 100%; border: 0; background: transparent; color: inherit; font: inherit; cursor: pointer; }
.arkme-redesign-profile-head > span { min-width: 0; display: grid; gap: 4px; text-align: left; }
.arkme-redesign-profile-head strong { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 14px; font-weight: 600; }
.arkme-redesign-profile-head small { color: #8b8f98; font-size: 11px; font-weight: 400; }
.arkme-redesign-profile-menu { display: grid; gap: 2px; padding-top: 6px; border-top: 1px solid #eeeeef; }
.arkme-redesign-profile-menu button { width: 100%; min-height: 50px; padding: 7px 8px; display: grid; grid-template-columns: 28px minmax(0,1fr) 16px; align-items: center; gap: 8px; border: 0; border-radius: 11px; outline: 0; background: transparent; box-shadow: none; color: #393d46; font: inherit; text-align: left; cursor: pointer; }
.arkme-redesign-profile-menu button:not([data-arkme-feedback]):hover { background: #f4f4f5; }
.arkme-redesign-profile-menu button > span { min-width: 0; display: grid; gap: 3px; }
.arkme-redesign-profile-menu strong { font-size: 12px; font-weight: 500; }
.arkme-redesign-profile-menu small { overflow: hidden; color: #92969f; font-size: 10px; font-weight: 400; white-space: nowrap; text-overflow: ellipsis; }
.arkme-redesign-profile-menu button > svg:last-child { color: #a0a3aa; }
.arkme-redesign-native-settings-trigger { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }

.arkme-redesign-chat-panel {
  position: absolute;
  inset: var(--arkme-native-titlebar) auto 0 96px;
  z-index: 3;
  width: 300px;
  min-width: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid var(--arkme-line);
  background: #fff;
}
.arkme-redesign-chat-search {
  width: 100%;
  height: 40px;
  margin: 20px 0 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 9px;
  border: 1px solid #e1e2e5 !important;
  border-radius: 11px;
  color: #9699a1 !important;
  font-size: 11px !important;
  text-align: left;
}
.arkme-redesign-chat-search:not([data-arkme-feedback]):hover { background: #f7f7f8; }
.arkme-redesign-chat-directory { min-height: 0; flex: 1; margin: 0; overflow: hidden; }
.arkme-redesign-chat-directory > section {
  background: transparent !important;
}

/* Conversation cards share feedback across native entries, extensions and virtualized rows. */
[data-arkme-overlay-scroll-viewport] { scrollbar-gutter: auto; }
[data-arkme-overlay-scroll-viewport]::-webkit-scrollbar { display: none; width: 0; height: 0; }
[data-arkme-overlay-scroll-thumb] {
  position: absolute; z-index: 3; top: 0; right: 0; width: 8px;
  box-sizing: border-box; border: 1px solid transparent; border-radius: 5px;
  background: color-mix(in srgb, var(--dsw-alias-label-primary, #17191c) 26%, transparent);
  background-clip: padding-box; opacity: 0; pointer-events: none;
  touch-action: none; user-select: none; cursor: default; transition: opacity .18s ease;
}
[data-arkme-scroll-visible="true"] > [data-arkme-overlay-scroll-thumb],
[data-arkme-overlay-scroll-thumb]:focus-visible { opacity: 1; pointer-events: auto; }
[data-arkme-overlay-scroll-thumb]:hover,
[data-arkme-scroll-dragging="true"] > [data-arkme-overlay-scroll-thumb] {
  background-color: color-mix(in srgb, var(--dsw-alias-label-primary, #17191c) 42%, transparent);
}
[data-arkme-overlay-scroll-thumb]:focus-visible { outline: 2px solid var(--dsw-alias-brand-primary, #9eadff); outline-offset: -2px; }
@media (prefers-reduced-motion: reduce) { [data-arkme-overlay-scroll-thumb] { transition: none; } }
[aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] {
  --arkme-directory-card-hover: var(--arkme-control-hover-surface, #f1f2f6);
  --arkme-directory-card-selected-hover: var(--arkme-directory-card-hover);
}
body[data-ds-dark-theme] [aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] {
  --arkme-directory-card-hover: var(--dsw-alias-interactive-bg-active, rgba(255, 255, 255, .1));
}
[aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] button[role="treeitem"] {
  transition: background-color .12s ease;
}
@media (hover: hover) {
  [aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] button[role="treeitem"]:not(:disabled):not([aria-disabled="true"]):not([aria-selected="true"]):hover {
    background-color: var(--arkme-directory-card-hover) !important;
  }
}
[aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] button[data-arkme-home-tour-target="harness"][aria-expanded="true"]:not([aria-selected="true"]) {
  background-color: var(--arkme-directory-card-hover) !important;
}
[aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] button[data-arkme-home-tour-target="harness"][aria-expanded="true"][aria-selected="true"] {
  background-color: var(--arkme-directory-card-selected-hover) !important;
}
@media (prefers-reduced-motion: reduce) {
  [aria-label="Arkme 会话列表"] [role="tree"][aria-label="Arkme 会话"] button[role="treeitem"] { transition: none; }
}
.arkme-redesign-task-section { position: relative; z-index: 3; height: 158px; margin: 0 6px 12px; outline: none; border-bottom: 1px solid #ececef; }
.arkme-redesign-task-section-title { height: 28px; padding: 0 7px; display: flex; align-items: center; justify-content: space-between; color: #767b85; }
.arkme-redesign-task-section-title strong { font-size: 12px; font-weight: 500; }
.arkme-redesign-task-section-title button { width: 24px; height: 24px; display: grid; place-items: center; border-radius: 7px; }
.arkme-redesign-task-section-title button:hover { background: #f3f3f5; }
.arkme-redesign-task-list { position: absolute; top: 28px; left: 0; right: 0; max-height: 128px; padding-bottom: 2px; display: grid; overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; scrollbar-gutter: stable; background: #fff; transition: max-height .18s ease, box-shadow .18s ease, padding .18s ease; }
.arkme-redesign-task-section:hover .arkme-redesign-task-list,
.arkme-redesign-task-section:focus-within .arkme-redesign-task-list { max-height: min(360px, calc(100vh - 180px)); padding-bottom: 6px; box-shadow: 0 14px 22px rgba(27,30,37,.07); }
.arkme-redesign-task-list > button {
  width: 100%;
  min-width: 0;
  height: 32px;
  padding: 0 8px;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  color: #555a64;
  text-align: left;
}
.arkme-redesign-task-list > button:hover { background: #f7f7f8; }
.arkme-redesign-task-list > button.is-selected { background: #f0f1f4; color: #232630; }
.arkme-redesign-task-state {
  width: 16px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.arkme-redesign-task-state.is-complete > i { position: relative; width: 10px; height: 10px; display: block; border-radius: 50%; background: rgba(57,165,107,.1); }
.arkme-redesign-task-state.is-complete > i::after { content: ""; position: absolute; inset: 2px; border-radius: 50%; background: #39a56b; }
.arkme-redesign-task-matrix { width: 10px; height: 10px; display: grid; grid-template-columns: repeat(3, 2px); grid-auto-rows: 2px; gap: 1px; }
.arkme-redesign-task-matrix i { border-radius: 1px; background: #5d76e8; opacity: .15; animation: arkme-task-dot-chase 1s infinite; }
.arkme-redesign-task-matrix i:nth-child(2) { animation-delay: .125s; }
.arkme-redesign-task-matrix i:nth-child(3) { animation-delay: .25s; }
.arkme-redesign-task-matrix i:nth-child(4) { animation-delay: .375s; }
.arkme-redesign-task-matrix i:nth-child(5) { animation-delay: .5s; }
.arkme-redesign-task-matrix i:nth-child(6) { animation-delay: .625s; }
.arkme-redesign-task-matrix i:nth-child(7) { animation-delay: .75s; }
.arkme-redesign-task-matrix i:nth-child(8) { animation-delay: .875s; }
@keyframes arkme-task-dot-chase { 0%, 12.4% { opacity: 1; } 12.5%, 24.9% { opacity: .6; } 25%, 37.4% { opacity: .35; } 37.5%, 100% { opacity: .15; } }
.arkme-redesign-task-copy { min-width: 0; display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.arkme-redesign-task-copy strong { min-width: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 14px; line-height: 20px; font-weight: 400; }
.arkme-redesign-task-copy small { flex: none; color: #9a9da5; font-size: 12px; line-height: 20px; }
.arkme-redesign-task-first { width: calc(100% - 12px); height: 32px; margin: 0 6px; padding: 0 8px; border-radius: 8px; color: #555a64; font-size: 14px; text-align: left; }
.arkme-redesign-task-first:hover { background: #f7f7f8; }

.arkme-redesign-content {
  position: absolute;
  inset: var(--arkme-native-titlebar) 0 0 96px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}
.arkme-redesign-content.has-panel { left: 396px; }
.arkme-redesign-content.has-details { right: 360px; }
.arkme-redesign-content.is-login-takeover { left: 0; right: 0; }
.arkme-redesign-route-surface { width: 100%; height: 100%; min-width: 0; min-height: 0; overflow: hidden; }
.arkme-redesign-route-chats .arkme-conversation-surface { background: #fff !important; }
.arkme-redesign-route-chats .arkme-conversation-header {
  height: 68px !important;
  padding: 12px 16px 12px 20px !important;
  border-bottom: 1px solid #ececef !important;
}
.arkme-redesign-route-chats .arkme-conversation-header h2 { font-size: 15px !important; font-weight: 600 !important; }
.arkme-redesign-route-chats .arkme-conversation-body { padding: 22px 22px 12px !important; }
/* DSH Input owns borders, typography, icon and focus. Its layer-1 fill is white
   and its dimmed placeholder is too faint on this dialog in the host theme;
   use semantic contrast tokens here without changing other native inputs. */
span.arkme-forward-search {
  width: 100%; height: 100%; box-sizing: border-box;
  background: var(--dsw-alias-bg-module-platform, #f5f6f7);
}
.arkme-forward-search input::placeholder { color: var(--dsw-alias-label-secondary, #61666b); }
.arkme-redesign-route-chats .arkme-conversation-records { width: 100% !important; gap: 0 !important; }
.arkme-conversation-records-reveal { animation: arkme-conversation-records-reveal 120ms ease-out both; }
@keyframes arkme-conversation-records-reveal {
  from { opacity: 0; }
  to { opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .arkme-conversation-records-reveal { animation: none; }
}
.arkme-redesign-route-chats [data-arkme-content-presentation="bubble"] p { font-size: 14px; line-height: 1.62; }
.arkme-redesign-route-chats .arkme-conversation-composer { padding: 0 24px 20px !important; }
.arkme-redesign-route-chats .arkme-conversation-composer-inner {
  width: 100% !important;
  gap: 8px !important;
  padding: 12px 13px 9px !important;
  border: 1px solid #dfe1e6 !important;
  border-radius: 15px !important;
  background: #fff !important;
  box-shadow: 0 8px 30px rgba(28, 31, 39, .045) !important;
}
.arkme-conversation-composer-inner[data-arkme-primary-composer="true"] {
  --arkme-primary-composer-idle: #f6f6f6;
  --arkme-primary-composer-focused: #ffffff;
  background: var(--arkme-primary-composer-idle, #f6f6f6) !important;
  box-shadow: none !important;
}
.arkme-conversation-composer-inner[data-arkme-primary-composer="true"][data-arkme-composer-focused="true"] {
  background: var(--arkme-primary-composer-focused, #ffffff) !important;
}
.arkme-redesign-route-chats .arkme-conversation-composer textarea { min-height: 38px !important; padding: 0 !important; font-size: 14px !important; line-height: 22px !important; }
.arkme-redesign-task-conversation { font-size: 15px; }
.arkme-redesign-task-conversation [data-phase] {
  --dsh-chat-content-width: calc(100% - 64px);
  --dsh-composer-card-max-width: calc(100% - 32px);
}
.arkme-redesign-task-conversation [data-chat-flow] {
  width: calc(100% - 64px) !important;
  max-width: none !important;
  margin-left: 32px !important;
  margin-right: 32px !important;
}
.arkme-redesign-task-conversation textarea { font-size: 14px !important; }
/* Keep both Arkme navigation columns visible at every viewport width. DSH may
   report its sidebar as collapsed at 1024px; the plugin still owns its navigation rail
   and at least a 120px directory with search/add controls (plus the 4px divider budget). */
/* Harness 0.1.5 renamed the collapsed third-column marker from details to rightbar. */
[data-slot="root"] > div:is([data-details-collapsed="true"], [data-rightbar-collapsed="true"]):has([data-arkme-owned="persistent-sidebar"][data-arkme-login-mode="false"][data-arkme-directory-visible="true"] [data-arkme-directory-mode="conversations"]) {
  grid-template-columns: var(--arkme-persistent-sidebar-width, calc(var(--arkme-navigation-width) + 284px)) minmax(0, 1fr) 0 !important;
}
[data-slot="root"] > div:is([data-details-collapsed="true"], [data-rightbar-collapsed="true"]):has([data-arkme-owned="persistent-sidebar"][data-arkme-web-locked] [data-arkme-directory-mode="web-locked"]) {
  grid-template-columns: var(--arkme-persistent-sidebar-width, calc(var(--arkme-navigation-width) + 284px)) minmax(0, 1fr) 0 !important;
}
[data-slot="root"] > div:is([data-details-collapsed="true"], [data-rightbar-collapsed="true"]):has([data-arkme-owned="persistent-sidebar"][data-arkme-login-mode="false"][data-arkme-directory-visible="false"]) {
  grid-template-columns: var(--arkme-navigation-width) minmax(0, 1fr) 0 !important;
}
@media (min-width: 1100px) {
  [data-slot="root"] > div:is([data-details-collapsed="true"], [data-rightbar-collapsed="true"]):has([data-arkme-owned="persistent-sidebar"][data-arkme-login-mode="false"] [data-arkme-directory-mode="contacts"]) {
    grid-template-columns: var(--arkme-persistent-sidebar-width, calc(var(--arkme-navigation-width) + 284px)) minmax(0, 1fr) 0 !important;
  }
  [data-slot="root"] > div:is([data-details-collapsed="true"], [data-rightbar-collapsed="true"]):has([data-arkme-owned="persistent-sidebar"][data-arkme-login-mode="true"]:not([data-arkme-web-locked])) {
    grid-template-columns: 0 minmax(0, 1fr) 0 !important;
  }
}

[data-arkme-owned="persistent-sidebar"][data-arkme-login-mode="false"]:has(> [data-arkme-directory-mode="conversations"]) > [data-arkme-owned="product-navigation"] {
  width: var(--arkme-navigation-width) !important;
  min-width: var(--arkme-navigation-width) !important;
  flex: 0 0 var(--arkme-navigation-width) !important;
}
[data-arkme-owned="persistent-sidebar"] :is([data-arkme-directory-mode="conversations"], [data-arkme-directory-mode="web-locked"]) { min-width: 120px !important; }
/* Only the search label condenses. Conversation rows retain their left anchor
   and continuously truncate text instead of switching to an avatar-only layout. */
[data-arkme-directory-compact="true"] [data-arkme-directory-search] { flex: none !important; width: 40px; padding: 0 !important; justify-content: center; }
[data-arkme-directory-compact="true"] [data-arkme-directory-search-label] { display: none !important; }

[data-arkme-harness-summary] { min-width: 0; display: flex; flex-wrap: nowrap; overflow: hidden; gap: 2px 8px; font-size: 11px; line-height: 16px; }
[data-arkme-harness-status] { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }
[data-arkme-harness-status="running"] { color: #4279d4; }
[data-arkme-harness-status="unread"] { color: #278557; }
[data-arkme-harness-status="pending"] { color: #a96b0a; }
[data-arkme-harness-status] > i { width: 5px; height: 5px; flex: none; border-radius: 50%; background: currentColor; }
[data-arkme-harness-status="running"] > i { width: 7px; height: 7px; background: transparent; border: 1.5px solid currentColor; border-right-color: transparent; box-sizing: border-box; animation: arkme-harness-running 1.1s linear infinite; }
[data-arkme-harness-badge] { display: none; position: absolute; right: -3px; top: -3px; min-width: 15px; height: 15px; padding: 0 3px; box-sizing: border-box; border: 1px solid #fff; border-radius: 9px; color: #fff; font-size: 9px; line-height: 13px; font-weight: 600; justify-content: center; align-items: center; }
[data-arkme-harness-badge][data-kind="running"] { background: #4279d4; }
[data-arkme-harness-badge][data-kind="unread"] { background: #278557; }
[data-arkme-harness-badge][data-kind="pending"] { background: #a96b0a; }
[data-arkme-harness-badge][data-idle="true"] { display: inline-flex; }
[data-arkme-directory-compact="true"] [data-arkme-harness-badge] { display: inline-flex; }
@keyframes arkme-harness-running { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { [data-arkme-harness-status="running"] > i { animation: none; } }

.arkme-redesign-feature-page {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 30px 48px 36px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
}
.arkme-redesign-feature-page > header { flex: none; margin: 0 0 22px; }
.arkme-redesign-feature-page > header p { margin: 0 0 8px; color: #8d9098; font-size: 11px; }
.arkme-redesign-feature-page > header h1 { margin: 0; font-size: 27px; font-weight: 600; letter-spacing: -.04em; }
.arkme-redesign-feature-page > header span { display: block; margin-top: 10px; color: #858992; font-size: 12px; }
.arkme-redesign-feature-body { min-height: 0; flex: 1; overflow: hidden; }

.arkme-redesign-recordings-page { padding: 0; background: #fff; }
.arkme-redesign-recordings-page > div { height: 100% !important; }

.arkme-redesign-search-page { padding: 66px 0 40px; }
.arkme-redesign-search-page > header,
.arkme-redesign-search-page > .arkme-redesign-feature-body { width: min(980px, calc(100% - 80px)); margin-left: auto; margin-right: auto; }
.arkme-redesign-search-page > header { margin-bottom: 28px; }
.arkme-redesign-search-page > header h1 { font-size: 32px; }
.arkme-redesign-search-page .arkme-redesign-feature-body { overflow-y: auto; }
.arkme-redesign-search-page .arkme-redesign-feature-body > div { width: 100% !important; padding: 0 !important; }
.arkme-redesign-search-page .arkme-redesign-feature-body > div > header { display: none !important; }
.arkme-redesign-search-page .arkme-search-box {
  height: 68px !important;
  gap: 12px !important;
  padding: 0 20px !important;
  border: 1px solid #e1e2e5 !important;
  border-radius: 15px !important;
  background: #fff !important;
  color: #646872 !important;
  box-shadow: 0 8px 28px rgba(28, 31, 39, .035);
}
.arkme-redesign-search-page input[aria-label="搜索"] { font-size: 14px !important; }
.arkme-redesign-search-page input[aria-label="搜索"]:not(:focus)::placeholder { color: #92959d; }
.arkme-redesign-search-page .arkme-search-history,
.arkme-redesign-search-page .arkme-search-quick { margin: 24px 0 0 !important; }
.arkme-redesign-search-page .arkme-search-history > div,
.arkme-redesign-search-page .arkme-search-quick > div { display: grid !important; gap: 0 !important; }
.arkme-redesign-search-page .arkme-search-history button,
.arkme-redesign-search-page .arkme-search-quick button {
  width: 100% !important;
  height: 52px !important;
  padding: 0 6px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 14px !important;
  overflow: hidden;
  border: 0 !important;
  border-bottom: 1px solid #e6e7e9 !important;
  border-radius: 0 !important;
  color: #30333b !important;
  font-size: 12px !important;
  text-align: left;
}
.arkme-redesign-search-page .arkme-search-history button span,
.arkme-redesign-search-page .arkme-search-quick button span { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }

.arkme-redesign-plugins-page { background: #fff; }
.arkme-redesign-plugins-page .arkme-extension-center-embedded > section { background: #fff !important; }
.arkme-redesign-plugins-page .arkme-extension-center-embedded header { display: none !important; }
.arkme-extension-toolbar { height: 46px; display: flex; align-items: center; gap: 12px; }
.arkme-extension-toolbar label {
  min-width: 0;
  flex: 1;
  height: 44px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e1e2e5;
  border-radius: 12px;
  color: #8e929a;
}
.arkme-extension-toolbar input { min-width: 0; flex: 1; border: 0; outline: 0; background: transparent; color: #262932; font-size: 12px; }
.arkme-extension-toolbar > button { height: 38px; padding: 0 15px; border: 1px solid #e1e2e5 !important; border-radius: 11px; font-size: 11px; }
.arkme-extension-toolbar > button:hover { background: #f6f6f7; }
.arkme-redesign-plugins-page .arkme-extension-center-embedded nav { width: 420px; height: 38px !important; padding: 0 !important; }
.arkme-redesign-plugins-page .arkme-extension-center-embedded main {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-content: start;
  gap: 12px;
  padding: 16px 0 0 !important;
}
.arkme-redesign-plugins-page .arkme-extension-card {
  min-height: 138px !important;
  margin: 0 !important;
  padding: 18px !important;
  border: 1px solid #e3e4e7 !important;
  border-radius: 15px !important;
  background: #fff !important;
}
.arkme-redesign-plugins-page .arkme-extension-card:hover { border-color: #d5d7dc !important; background: #fafafa !important; }
.arkme-redesign-plugins-page .arkme-extension-grid-span,
.arkme-redesign-plugins-page .arkme-extension-center-embedded main > [role="status"],
.arkme-redesign-plugins-page .arkme-extension-center-embedded main > [role="alert"] { grid-column: 1 / -1; }
@keyframes arkme-icon-spin { to { transform: rotate(360deg); } }
.arkme-icon-spin { animation: arkme-icon-spin .8s linear infinite; }
@media (prefers-reduced-motion: reduce) {
  [data-arkme-voice] .arkme-icon-spin { animation: none; }
}

.arkme-redesign-settings-surface { width: 100%; height: auto; overflow: visible; color: #20232c; background: transparent; }
.arkme-redesign-settings-shell { width: 100%; box-sizing: border-box; margin: 0; padding: 0; }
.arkme-redesign-settings-profile { padding: 0 0 24px; display: flex; align-items: center; gap: 16px; }
.arkme-redesign-settings-profile > div:nth-child(2) { min-width: 0; }
.arkme-redesign-settings-profile h1 { margin: 0 0 6px; overflow: hidden; color: #20232c; font-size: 24px; line-height: 30px; font-weight: 600; letter-spacing: -.03em; white-space: nowrap; text-overflow: ellipsis; }
.arkme-redesign-settings-profile p {
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #858992;
  font-size: 13px;
  line-height: 18px;
}
.arkme-redesign-settings-profile p > span {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.arkme-account-profile-qr {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #858992;
  cursor: pointer;
}
.arkme-account-profile-qr:disabled { opacity: .55; cursor: default; }
.arkme-account-profile-qr svg { width: 20px; height: 20px; display: block; }
.arkme-redesign-settings-group { margin: 0; overflow: hidden; border: 0; border-bottom: 1px solid #e1e2e5; border-radius: 0; background: transparent; }
.arkme-redesign-settings-group:last-child { border-bottom: 0; }
.arkme-redesign-settings-group > h2 { margin: 0; padding: 15px 1px 10px; border-bottom: 1px solid #ededee; color: #8a8e96; font-size: 12px; line-height: 17px; font-weight: 500; }
.arkme-redesign-settings-group > div { padding: 0; }
.arkme-redesign-setting-row {
  width: 100%;
  box-sizing: border-box;
  min-height: 54px;
  padding: 9px 1px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 18px;
  align-items: center;
  gap: 10px;
  border: 0;
  border-bottom: 1px solid #ededee;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  text-decoration: none;
}
.arkme-redesign-setting-row:last-child { border-bottom: 0; }
button.arkme-redesign-setting-row, a.arkme-redesign-setting-row { cursor: pointer; }
button.arkme-redesign-setting-row:not([data-arkme-feedback]):hover, a.arkme-redesign-setting-row:hover { color: #53617d; }
.arkme-redesign-setting-row:disabled { opacity: .6; cursor: default; }
.arkme-redesign-setting-row > strong { overflow: hidden; font-size: 14px; line-height: 20px; font-weight: 500; white-space: nowrap; text-overflow: ellipsis; }
.arkme-redesign-setting-row > strong.is-danger { color: #b54841; }
.arkme-redesign-setting-summary { max-width: 360px; overflow: hidden; color: #858992; font-size: 12px; line-height: 18px; text-align: right; white-space: nowrap; text-overflow: ellipsis; }
.arkme-redesign-setting-row > svg { color: #8d929b; }
.arkme-account-info-row {
  width: 100%;
  box-sizing: border-box;
  min-height: 54px;
  padding: 9px 1px;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) auto 18px;
  align-items: center;
  gap: 10px;
  border: 0;
  border-bottom: 1px solid #ededee;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
}
.arkme-account-info-row:last-child { border-bottom: 0; }
button.arkme-account-info-row { cursor: pointer; }
.arkme-account-info-row:disabled { opacity: .6; cursor: default; }
.arkme-account-info-icon {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6f7580;
}
.arkme-account-info-copy { min-width: 0; display: grid; gap: 2px; }
.arkme-account-info-copy > strong { overflow: hidden; font-size: 14px; line-height: 20px; font-weight: 500; white-space: nowrap; text-overflow: ellipsis; }
.arkme-account-info-copy > small { overflow: hidden; color: #858992; font-size: 12px; line-height: 18px; white-space: nowrap; text-overflow: ellipsis; }
.arkme-account-info-action { color: #858992; font-size: 12px; line-height: 18px; white-space: nowrap; }
.arkme-account-info-row > svg { color: #8d929b; }

/* Confirmed account layout; native DSH settings controls retain their own styles. */
[data-arkme-settings-view="account"] .arkme-redesign-settings-profile > div:nth-child(2) { flex: 1; }
[data-arkme-settings-view="account"] .arkme-redesign-settings-profile h1 { margin: 0; }
[data-arkme-settings-view="account"] .arkme-redesign-settings-group { border-bottom: 0; }
[data-arkme-settings-view="account"] .arkme-account-info-row { grid-template-columns: 26px minmax(0, 1fr) 48px 18px; min-height: 54px; border-bottom: 0; }
[data-arkme-settings-view="account"] .arkme-account-info-copy { grid-template-columns: minmax(70px, 1fr) minmax(0, auto); align-items: center; gap: 16px; }
[data-arkme-settings-view="account"] .arkme-account-info-copy > small { text-align: right; }
[data-arkme-settings-view="account"] .arkme-account-info-action { text-align: center; }
[data-arkme-settings-view="account"] .arkme-redesign-settings-group:has(.arkme-redesign-balance-row) { margin-top: 16px; }
[data-arkme-settings-view="account"] .arkme-redesign-balance-main > small { color: inherit; font-size: 28px; line-height: 38px; font-weight: 600; }
.arkme-account-logout { display: flex; justify-content: center; padding-top: 32px; }
.arkme-account-logout > button { min-width: 128px; min-height: 40px; padding: 8px 24px; border: 1px solid #e1e2e5; border-radius: 8px; background: transparent; color: #dc4d43; font: inherit; cursor: pointer; }
.arkme-account-logout > button:disabled { cursor: default; opacity: .6; }
[data-arkme-settings-view="general"] .arkme-redesign-settings-group:last-child { border-bottom: 0; }
.arkme-about-heading { margin: 0 0 20px; color: inherit; font: inherit; font-size: 18px; font-weight: 600; line-height: 1.5; }
.arkme-account-feedback {
  margin: 8px 0 14px;
  display: flex;
  gap: 6px;
  align-items: flex-start;
  color: #b54841;
  font-size: 12px;
  line-height: 18px;
}
.arkme-account-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(18, 20, 26, .42);
}
.arkme-account-dialog {
  width: min(420px, calc(100vw - 36px));
  max-height: calc(100vh - 56px);
  overflow: auto;
  box-sizing: border-box;
  border: 1px solid #e1e2e5;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 18px 52px rgba(17, 24, 39, .22);
  color: #20232c;
}
.arkme-account-dialog > header {
  height: 58px;
  padding: 0 16px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ededee;
}
.arkme-account-dialog h3 { margin: 0; font-size: 18px; line-height: 24px; font-weight: 650; }
.arkme-account-dialog > header button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #8d929b;
  cursor: pointer;
}
.arkme-account-qr-card {
  margin: 22px auto 16px;
  width: 270px;
  box-sizing: border-box;
  padding: 24px 22px 22px;
  display: grid;
  justify-items: center;
  gap: 7px;
  border: 1px solid #ededee;
  border-radius: 14px;
  background: #fff;
}
.arkme-account-qr-card strong { max-width: 100%; min-width: 0; margin-top: 4px; font-size: 17px; line-height: 23px; font-weight: 650; text-align: center; overflow-wrap: anywhere; }
.arkme-account-qr-card span, .arkme-account-qr-card small { color: #858992; font-size: 12px; line-height: 18px; }
.arkme-account-qr-card img { width: 180px; height: 180px; margin-top: 8px; }
.arkme-account-form { padding: 18px 20px 20px; display: grid; gap: 12px; }
.arkme-account-form label { display: grid; gap: 7px; color: #5f6570; font-size: 12px; line-height: 18px; }
.arkme-account-form input {
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  border: 1px solid #dfe1e5;
  border-radius: 11px;
  padding: 0 12px;
  background: #fff;
  color: #20232c;
  font: inherit;
  outline: none;
}
.arkme-account-form input:focus { border-color: #9aa7c2; box-shadow: 0 0 0 3px rgba(83, 97, 125, .12); }
.arkme-account-rule { margin: -2px 0 0; color: #858992; font-size: 12px; line-height: 18px; }
.arkme-account-code-row { display: grid; grid-template-columns: minmax(0, 1fr) 92px; gap: 8px; }
.arkme-account-code-row button {
  border: 1px solid #dfe1e5;
  border-radius: 11px;
  background: #fff;
  color: #343944;
  font: inherit;
  cursor: pointer;
}
.arkme-account-code-row button:disabled { opacity: .55; cursor: default; }
.arkme-account-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 6px;
}
.arkme-account-dialog > .arkme-account-dialog-actions { padding: 6px 20px 20px; }
.arkme-account-dialog > .arkme-account-dialog-status { margin: 0 20px 16px; }
.arkme-account-dialog > .arkme-account-qr-card + .arkme-account-dialog-actions { justify-content: center; padding: 6px 20px 24px; }
.arkme-account-dialog > .arkme-account-qr-card ~ .arkme-account-dialog-status { margin: -8px 20px 20px; text-align: center; }
.arkme-account-dialog > .arkme-account-qr-card ~ .arkme-account-dialog-status:empty { display: none; }
.arkme-account-dialog-actions button {
  min-width: 78px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #dfe1e5;
  border-radius: 10px;
  background: #fff;
  color: #343944;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font: inherit;
  cursor: pointer;
}
.arkme-account-dialog-actions button[type="submit"],
.arkme-account-dialog-actions button:last-child {
  border-color: #20232c;
  background: #20232c;
  color: #fff;
}
.arkme-account-dialog-actions button:disabled { opacity: .55; cursor: default; }
.arkme-account-dialog-status { margin: 0; color: #13a85b; font-size: 12px; line-height: 18px; }
.arkme-account-dialog-status.is-error { color: #b54841; }
.arkme-redesign-version-row { grid-template-columns: minmax(0, 1fr) minmax(150px, auto) auto 18px; }
.arkme-redesign-version-row.is-without-action { grid-template-columns: minmax(0, 1fr) auto 18px; }
.arkme-redesign-version-copy { min-width: 0; display: grid; gap: 2px; }
.arkme-redesign-version-copy > strong { overflow: hidden; font-size: 14px; line-height: 20px; font-weight: 500; white-space: nowrap; text-overflow: ellipsis; }
.arkme-redesign-version-copy > small { overflow: hidden; color: #858992; font-size: 11px; line-height: 16px; white-space: nowrap; text-overflow: ellipsis; }
.arkme-redesign-version-value { justify-self: end; color: #858992; font-size: 12px; line-height: 18px; white-space: nowrap; }
.arkme-redesign-version-action-slot { display: inline-flex; justify-content: flex-end; }
.arkme-redesign-trailing-slot { width: 18px; height: 1px; }
button.arkme-redesign-update-button {
  min-width: 72px;
  height: 30px;
  padding: 0 11px;
  border: 1px solid #dfe1e5;
  border-radius: 9px;
  background: #fff;
  color: #343944;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font: inherit;
  font-size: 11px;
  white-space: nowrap;
  cursor: pointer;
}
button.arkme-redesign-update-button:not([data-arkme-feedback]):hover { background: #f7f7f8; border-color: #cfd3da; }
button.arkme-redesign-update-button:disabled { opacity: .55; cursor: default; }
.arkme-redesign-settings-group:has(.arkme-redesign-balance-row) { overflow: visible; }
.arkme-redesign-balance-row {
  grid-template-columns: max-content max-content minmax(0, 1fr) 18px;
  column-gap: 20px;
}
.arkme-redesign-balance-row.is-without-reserved { grid-template-columns: max-content minmax(0, 1fr) 18px; }
.arkme-redesign-balance-main {
  min-width: 0;
  padding: 0;
  display: grid;
  gap: 2px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.arkme-redesign-balance-main > strong { font-size: 14px; line-height: 20px; font-weight: 500; }
.arkme-redesign-balance-main > small { color: #858992; font-size: 12px; line-height: 18px; }
.arkme-redesign-balance-usage { color: #8a8e96; font-size: 11px; line-height: 16px; white-space: nowrap; }
.arkme-redesign-reserved-balance { min-width: 0; display: grid; gap: 2px; }
.arkme-redesign-recharge-trigger { justify-self: end; }
.arkme-redesign-reserved-title { width: fit-content; position: relative; display: inline-flex; align-items: center; gap: 5px; }
.arkme-redesign-reserved-title > strong { font-size: 14px; line-height: 20px; font-weight: 500; }
.arkme-redesign-reserved-balance > small { color: #858992; font-size: 12px; line-height: 18px; }
.arkme-redesign-reserved-help {
  width: 15px;
  height: 15px;
  box-sizing: border-box;
  display: inline-grid;
  place-items: center;
  border: 1px solid #a6aab2;
  border-radius: 50%;
  color: #858992;
  font-size: 10px;
  line-height: 1;
  font-weight: 600;
  cursor: help;
}
.arkme-redesign-reserved-help:focus-visible { outline: 2px solid #7b8cad; outline-offset: 2px; }
.arkme-redesign-reserved-title > [role="tooltip"] {
  width: 240px;
  box-sizing: border-box;
  position: absolute;
  z-index: 20;
  bottom: calc(100% + 8px);
  left: calc(100% - 7.5px);
  padding: 9px 11px;
  border-radius: 8px;
  background: #2e323b;
  color: #fff;
  box-shadow: 0 6px 18px rgba(24, 27, 34, .18);
  font-size: 11px;
  line-height: 17px;
  font-weight: 400;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(-50%, 2px);
  transition: opacity .12s ease, transform .12s ease, visibility .12s ease;
}
.arkme-redesign-reserved-help:hover ~ [role="tooltip"],
.arkme-redesign-reserved-help:focus ~ [role="tooltip"] { opacity: 1; visibility: visible; transform: translate(-50%, 0); }
.arkme-redesign-settings-error { margin: -8px 0 28px; padding: 10px 13px; border-radius: 10px; background: #fff3f0; color: #b54841; font-size: 12px; line-height: 18px; }

/* DSH remote settings follows the compact connection-management pattern:
   persistent controls stay on the page; one-time pairing stays in a dialog. */
.arkme-remote-settings-dialog-backdrop { position: fixed; inset: 0; z-index: 1150; padding: 24px; box-sizing: border-box; display: grid; place-items: center; background: rgba(22, 24, 29, .28); backdrop-filter: blur(1.5px); }
.arkme-remote-settings-dialog { width: min(720px, calc(100vw - 48px)); max-height: min(720px, calc(100vh - 48px)); display: flex; flex-direction: column; overflow: hidden; border: 1px solid rgba(20, 24, 32, .08); border-radius: 19px; background: #fff; color: #20232c; box-shadow: 0 18px 54px rgba(17, 20, 27, .18); }
.arkme-remote-page-header { min-height: 74px; padding: 0 24px 0 28px; box-sizing: border-box; display: flex; align-items: center; justify-content: space-between; gap: 20px; border-bottom: 1px solid #ededee; }
.arkme-remote-page-header > div { min-width: 0; }
.arkme-remote-page-header h1 { margin: 0; color: #20232c; font-size: 18px; line-height: 25px; font-weight: 620; letter-spacing: -.02em; }
.arkme-remote-page-header p { margin: 3px 0 0; color: #8b9098; font-size: 11px; line-height: 17px; }
.arkme-remote-settings-close { width: 32px; height: 32px; flex: 0 0 auto; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 9px; background: transparent; color: #777c85; cursor: pointer; }
.arkme-remote-settings-close:hover { background: #f3f3f4; color: #20232c; }
.arkme-remote-settings-dialog-body { padding: 24px 28px 28px; display: grid; gap: 28px; overflow-y: auto; overscroll-behavior: contain; }
.arkme-remote-section { display: grid; gap: 13px; }
.arkme-remote-section-header { min-height: 34px; display: flex; align-items: flex-end; justify-content: space-between; gap: 18px; }
.arkme-remote-section-header > div:first-child { min-width: 0; }
.arkme-remote-section-header h2 { margin: 0; color: #292c34; font-size: 14px; line-height: 21px; font-weight: 600; }
.arkme-remote-section-header p { margin: 2px 0 0; color: #8b9098; font-size: 11px; line-height: 17px; }
.arkme-remote-section-header > div:last-child { display: flex; align-items: center; gap: 8px; }
.arkme-remote-icon-button { width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 9px; background: transparent; color: #8a8f97; cursor: pointer; }
.arkme-remote-icon-button:hover { background: #f3f3f4; color: #343944; }
.arkme-remote-add-button { min-height: 32px; padding: 0 12px; display: inline-flex; align-items: center; gap: 5px; border: 0; border-radius: 9px; background: #20232c; color: #fff; font: inherit; font-size: 11px; font-weight: 550; cursor: pointer; }
.arkme-remote-add-button:hover { background: #343944; }
.arkme-remote-add-button:disabled, .arkme-remote-icon-button:disabled { opacity: .45; cursor: default; }
.arkme-remote-settings-card { overflow: hidden; border: 1px solid #e1e2e5; border-radius: 16px; background: #fff; }
.arkme-remote-allow-row { min-height: 60px; padding: 0 18px; display: flex; align-items: center; justify-content: space-between; gap: 18px; border-bottom: 1px solid #ededee; }
.arkme-remote-allow-row > div { min-width: 0; display: grid; gap: 2px; }
.arkme-remote-allow-row strong, .arkme-remote-device-row strong, .arkme-remote-name-row strong { color: #343944; font-size: 12px; line-height: 18px; font-weight: 600; }
.arkme-remote-allow-row span, .arkme-remote-device-row span, .arkme-remote-name-row small { overflow: hidden; color: #8b9098; font-size: 10px; line-height: 16px; white-space: nowrap; text-overflow: ellipsis; }
.arkme-remote-switch { position: relative; width: 40px; height: 23px; flex: 0 0 auto; padding: 0; border: 0; border-radius: 999px; background: #d7d9dd; cursor: pointer; transition: background .16s ease; }
.arkme-remote-switch > span { position: absolute; top: 3px; left: 3px; width: 17px; height: 17px; border-radius: 50%; background: #fff; box-shadow: 0 1px 3px rgba(20, 24, 32, .22); transition: transform .16s ease; }
.arkme-remote-switch[aria-checked="true"] { background: #3b9cf5; }
.arkme-remote-switch[aria-checked="true"] > span { transform: translateX(17px); }
.arkme-remote-switch:disabled { opacity: .5; cursor: default; }
.arkme-remote-device-row { min-height: 64px; padding: 0 18px; display: grid; grid-template-columns: 24px minmax(0, 1fr) auto; align-items: center; gap: 11px; border-bottom: 1px solid #ededee; }
.arkme-remote-device-row:last-child { border-bottom: 0; }
.arkme-remote-device-row > svg { color: #68707c; }
.arkme-remote-device-row > div { min-width: 0; display: grid; gap: 1px; }
.arkme-remote-device-row > button { min-height: 30px; padding: 0 10px; border: 0; border-radius: 9px; background: #f3f3f4; color: #5d626c; font: inherit; font-size: 10px; cursor: pointer; }
.arkme-remote-device-row > button:hover { background: #fff0ed; color: #b54841; }
.arkme-remote-device-row > button:disabled { opacity: .45; cursor: default; }
.arkme-remote-empty-row { min-height: 52px; padding: 0 18px; display: flex; align-items: center; gap: 11px; color: #989ca3; font-size: 11px; }
.arkme-remote-empty-row > svg { color: #a2a6ad; }
.arkme-remote-name-row { width: 100%; min-height: 62px; padding: 0 18px; display: grid; grid-template-columns: 24px minmax(0, 1fr) 20px; align-items: center; gap: 11px; border: 0; background: transparent; color: #727780; font: inherit; text-align: left; cursor: pointer; }
.arkme-remote-name-row:hover { background: #fafafb; }
.arkme-remote-name-row > span { min-width: 0; display: grid; gap: 1px; }
.arkme-remote-name-row small { display: block; }
.arkme-remote-rename { padding: 12px 18px; display: grid; grid-template-columns: minmax(0, 1fr) auto auto; gap: 7px; border-top: 1px solid #ededee; }
.arkme-remote-rename input { min-width: 0; height: 34px; box-sizing: border-box; padding: 0 10px; border: 1px solid #dfe1e5; border-radius: 9px; outline: 0; background: #fff; color: #20232c; font: inherit; font-size: 12px; }
.arkme-remote-rename input:focus { border-color: #6eb3f3; box-shadow: 0 0 0 3px rgba(59, 156, 245, .12); }
.arkme-remote-rename button { min-height: 34px; padding: 0 11px; border: 1px solid #e0e1e4; border-radius: 9px; background: #fff; color: #4f5560; font: inherit; font-size: 11px; cursor: pointer; }
.arkme-remote-rename button[type="submit"] { border-color: #20232c; background: #20232c; color: #fff; }
.arkme-remote-rename button:disabled { opacity: .5; cursor: default; }
.arkme-remote-error { margin: -22px 0 0; }
.arkme-remote-dialog-backdrop { position: fixed; inset: 0; z-index: 1200; padding: 24px; box-sizing: border-box; display: grid; place-items: center; overflow: auto; background: rgba(22, 24, 29, .28); backdrop-filter: blur(1.5px); }
.arkme-remote-dialog { position: relative; width: min(440px, calc(100vw - 32px)); max-height: calc(100vh - 48px); box-sizing: border-box; padding: 28px; overflow: auto; border: 1px solid rgba(20, 24, 32, .08); border-radius: 19px; background: #fff; color: #20232c; box-shadow: 0 18px 54px rgba(17, 20, 27, .18); }
.arkme-remote-dialog-close { position: absolute; top: 16px; right: 16px; width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 9px; background: transparent; color: #777c85; cursor: pointer; }
.arkme-remote-dialog-close:hover { background: #f3f3f4; color: #20232c; }
.arkme-remote-dialog-symbol { height: 38px; display: flex; align-items: center; justify-content: center; gap: 9px; color: #343944; }
.arkme-remote-dialog-symbol > span { width: 28px; height: 1px; background: #d6d8dc; }
.arkme-remote-dialog > header { margin: 12px 0 22px; text-align: center; }
.arkme-remote-dialog h2 { margin: 0; font-size: 19px; line-height: 27px; font-weight: 620; letter-spacing: -.02em; }
.arkme-remote-dialog header p { margin: 6px 0 0; color: #858992; font-size: 11px; line-height: 17px; }
.arkme-remote-pairing-tabs { height: 38px; padding: 3px; box-sizing: border-box; display: grid; grid-template-columns: 1fr 1fr; gap: 3px; border-radius: 11px; background: #f1f1f2; }
.arkme-remote-pairing-tabs button { border: 0; border-radius: 8px; background: transparent; color: #737881; font: inherit; font-size: 11px; cursor: pointer; }
.arkme-remote-pairing-tabs button[aria-selected="true"] { background: #fff; color: #252831; box-shadow: 0 1px 3px rgba(20, 24, 32, .09); }
.arkme-remote-pairing-display { position: relative; min-height: 308px; margin-top: 14px; box-sizing: border-box; padding: 24px; display: flex; flex-direction: column; align-items: center; justify-content: center; border: 1px solid #e5e6e8; border-radius: 16px; background: #fff; }
.arkme-remote-pairing-display > img { width: 232px; height: 232px; display: block; image-rendering: pixelated; }
.arkme-remote-pairing-display > p { margin: 10px 0 0; color: #8b9098; font-size: 10px; line-height: 16px; text-align: center; }
.arkme-remote-pairing-code { color: #20232c; font-size: 33px; line-height: 46px; font-weight: 620; letter-spacing: .17em; font-variant-numeric: tabular-nums; white-space: nowrap; user-select: all; }
.arkme-remote-pairing-tools { position: absolute; right: 12px; bottom: 12px; display: flex; gap: 4px; }
.arkme-remote-pairing-tools button { width: 30px; height: 30px; padding: 0; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 8px; background: transparent; color: #8a8f97; cursor: pointer; }
.arkme-remote-pairing-tools button:hover { background: #f3f3f4; color: #343944; }
.arkme-remote-pairing-expired { display: grid; justify-items: center; gap: 7px; text-align: center; }
.arkme-remote-pairing-expired strong { font-size: 14px; line-height: 20px; }
.arkme-remote-pairing-expired p { margin: 0; color: #8b9098; font-size: 11px; }
.arkme-remote-pairing-expired button { margin-top: 7px; min-height: 32px; padding: 0 12px; border: 0; border-radius: 9px; background: #20232c; color: #fff; font: inherit; font-size: 11px; cursor: pointer; }
.arkme-remote-dialog-note { margin: 14px 2px 0; display: flex; align-items: flex-start; gap: 7px; color: #858992; font-size: 10px; line-height: 16px; }
.arkme-remote-dialog-note > svg { margin-top: 1px; flex: 0 0 auto; color: #5e856d; }
.arkme-remote-settings-close:focus-visible, .arkme-remote-icon-button:focus-visible, .arkme-remote-add-button:focus-visible, .arkme-remote-switch:focus-visible, .arkme-remote-device-row > button:focus-visible, .arkme-remote-name-row:focus-visible, .arkme-remote-rename button:focus-visible, .arkme-remote-dialog button:focus-visible { outline: 2px solid #3b9cf5; outline-offset: 2px; }
@media (max-width: 520px) {
  .arkme-remote-settings-dialog-backdrop { padding: 10px; }
  .arkme-remote-settings-dialog { width: calc(100vw - 20px); max-height: calc(100vh - 20px); border-radius: 17px; }
  .arkme-remote-page-header { min-height: 68px; padding: 0 16px 0 20px; }
  .arkme-remote-page-header p { display: none; }
  .arkme-remote-settings-dialog-body { padding: 20px 18px 22px; gap: 24px; }
  .arkme-remote-section-header p { display: none; }
  .arkme-remote-device-row { grid-template-columns: 22px minmax(0, 1fr); padding-top: 10px; padding-bottom: 10px; }
  .arkme-remote-device-row > button { grid-column: 2; justify-self: start; }
  .arkme-remote-dialog-backdrop { padding: 12px; }
  .arkme-remote-dialog { padding: 24px 20px; }
  .arkme-remote-pairing-display { min-height: 282px; padding: 18px; }
  .arkme-remote-pairing-display > img { width: min(224px, 100%); height: auto; }
  .arkme-remote-pairing-code { font-size: 26px; letter-spacing: .12em; }
}
@media (prefers-reduced-motion: reduce) {
  .arkme-remote-switch, .arkme-remote-switch > span { transition: none; }
}
.arkme-redesign-model-settings { width: 100%; height: 100%; overflow-y: auto; color: #20232c; background: #fff; }
.arkme-redesign-model-settings > header { width: min(760px, calc(100% - 96px)); margin: 0 auto; padding: 42px 0 22px; }
.arkme-redesign-model-settings > header button {
  height: 34px;
  padding: 0 10px 0 7px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #e1e2e5;
  border-radius: 18px;
  background: #fff;
  color: #525762;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
.arkme-redesign-model-settings > header button:hover { background: #f6f6f7; color: #20232c; }
.arkme-redesign-model-settings-body { width: min(760px, calc(100% - 96px)); margin: 0 auto; padding: 0 0 68px; }
.arkme-redesign-model-settings-body > * { max-width: none !important; }
.arkme-redesign-task-start { width: 100%; height: 100%; display: grid; place-items: center; padding: 28px 58px 64px; }
.arkme-redesign-task-start-inner { width: min(760px, 88%); transform: translateY(-12px); text-align: center; }
.arkme-redesign-task-greeting { margin-bottom: 24px; display: flex; align-items: center; justify-content: center; gap: 12px; }
.arkme-redesign-task-greeting img { width: 62px; height: 16px; flex: none; display: block; object-fit: contain; }
.arkme-redesign-task-start h1 { margin: 0; font-size: 29px; line-height: 1.15; font-weight: 600; letter-spacing: -.03em; }
.arkme-redesign-hero-input {
  min-height: 142px;
  padding: 17px 16px 13px 20px;
  display: grid;
  grid-template-rows: minmax(56px, 1fr) auto;
  border: 1px solid var(--arkme-focus);
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(28, 31, 39, .045);
  text-align: left;
}
.arkme-redesign-hero-input:focus-within { border-color: #aebdff; box-shadow: 0 10px 38px rgba(54,72,140,.075), 0 0 0 3px rgba(145,164,255,.07); }
.arkme-redesign-hero-input textarea { width: 100%; min-height: 58px; padding: 0; resize: none; border: 0; outline: 0; color: #20232c; font-size: 15px; line-height: 1.6; }
.arkme-redesign-hero-input textarea::placeholder { color: #a3a6ad; }
.arkme-redesign-hero-controls { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.arkme-redesign-hero-controls > div { display: flex; align-items: center; gap: 7px; }
.arkme-redesign-source-button { height: 36px; padding: 0 13px; display: flex; align-items: center; gap: 8px; border: 1px solid #e2e3e6 !important; border-radius: 22px; font-size: 13px; }
.arkme-redesign-round-tool, .arkme-redesign-send-task { width: 40px; height: 40px; display: grid; place-items: center; border: 1px solid #e2e3e6 !important; border-radius: 50%; }
.arkme-redesign-round-tool:hover { background: #f5f5f6; }
.arkme-redesign-send-task { border: 0 !important; background: #20232d !important; color: #fff !important; }
.arkme-redesign-send-task:disabled { background: #d9dade !important; cursor: default; }
.arkme-redesign-task-error { margin-top: 10px; color: #b84747; font-size: 12px; text-align: left; }
.arkme-redesign-starters { width: calc(100% - 18px); margin: 22px auto 0; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); }
.arkme-redesign-starters > button { min-width: 0; min-height: 48px; padding: 4px 18px; display: flex; align-items: center; gap: 12px; border-right: 1px solid #e7e7e9; text-align: left; }
.arkme-redesign-starters > button:last-child { border-right: 0; }
.arkme-redesign-starters > button:hover strong { color: #5365ad; }
.arkme-redesign-starter-icon { width: 38px; height: 38px; flex: 0 0 auto; display: grid; place-items: center; border: 1px solid #e2e3e6; border-radius: 50%; color: #30333b; }
.arkme-redesign-starters > button > span:last-child { min-width: 0; display: grid; gap: 4px; }
.arkme-redesign-starters strong { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 13px; font-weight: 500; }
.arkme-redesign-starters small { color: #8d919a; font-size: 12px; }

.arkme-redesign-details { position: absolute; z-index: 4; top: var(--arkme-native-titlebar); right: 0; bottom: 0; width: 360px; overflow: hidden; border-left: 1px solid #e7e7e9; background: #fff; }
.arkme-redesign-calendar-overlay { position: absolute; z-index: 14; inset: var(--arkme-native-titlebar) 0 0; pointer-events: none; }
.arkme-redesign-calendar-overlay > * { pointer-events: auto; }
.arkme-redesign-overlays { position: absolute; z-index: 20; inset: 0; pointer-events: none; }
.arkme-redesign-overlays > * { pointer-events: auto; }
.arkme-workspace-dialog-backdrop { position: absolute; z-index: 60; inset: 0; display: grid; place-items: center; padding: 28px; background: rgba(24, 27, 34, .22); backdrop-filter: blur(2px); }
.arkme-workspace-dialog { width: min(640px, 100%); height: min(620px, 100%); min-height: 420px; display: grid; grid-template-rows: auto auto minmax(0, 1fr) auto; overflow: hidden; border: 1px solid #dddfe4; border-radius: 18px; background: #fff; box-shadow: 0 24px 70px rgba(25, 28, 35, .18); }
.arkme-workspace-dialog > header { padding: 22px 24px 16px; display: flex; align-items: flex-start; justify-content: space-between; gap: 18px; }
.arkme-workspace-dialog > header span { color: #8b8e96; font-size: 10px; }
.arkme-workspace-dialog > header h2 { margin: 5px 0 0; font-size: 19px; font-weight: 600; }
.arkme-workspace-dialog > header > button { width: 32px; height: 32px; display: grid; place-items: center; border-radius: 9px; }
.arkme-workspace-dialog > nav { min-height: 42px; padding: 0 22px; display: flex; align-items: center; gap: 2px; overflow-x: auto; border-top: 1px solid #ececef; border-bottom: 1px solid #ececef; }
.arkme-workspace-dialog > nav > span { display: inline-flex; align-items: center; gap: 2px; white-space: nowrap; color: #9a9da5; }
.arkme-workspace-dialog > nav button { height: 30px; padding: 0 7px; display: inline-flex; align-items: center; gap: 5px; border-radius: 8px; color: #666a73; font-size: 11px; }
.arkme-workspace-directory-list { min-height: 0; padding: 10px 14px; overflow-y: auto; }
.arkme-workspace-directory-list > button { width: 100%; height: 48px; padding: 0 11px; display: grid; grid-template-columns: 34px minmax(0, 1fr) 18px; align-items: center; gap: 9px; border-radius: 11px; text-align: left; }
.arkme-workspace-directory-list > button:hover { background: #f5f5f7; }
.arkme-workspace-directory-list > button > span { width: 32px; height: 32px; display: grid; place-items: center; border: 1px solid #e5e6e9; border-radius: 9px; color: #636873; }
.arkme-workspace-directory-list strong { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 12px; font-weight: 500; }
.arkme-workspace-dialog-status, .arkme-workspace-dialog-error { padding: 54px 16px; color: #8c9098; font-size: 12px; text-align: center; }
.arkme-workspace-dialog-error { color: #b94b4b; }
.arkme-workspace-dialog > footer { min-height: 72px; padding: 12px 18px; display: flex; align-items: center; justify-content: space-between; gap: 18px; border-top: 1px solid #e8e9ec; }
.arkme-workspace-dialog-back { height: 36px; padding: 0 10px; display: inline-flex; align-items: center; gap: 6px; color: #696d76; font-size: 11px; }
.arkme-workspace-dialog > footer > div { min-width: 0; display: flex; align-items: center; gap: 12px; }
.arkme-workspace-dialog > footer small { max-width: 280px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; color: #92959d; font-size: 9px; }
.arkme-workspace-dialog > footer > div > button { height: 38px; flex: none; padding: 0 17px; border-radius: 10px; background: #20232d; color: #fff; font-size: 11px; font-weight: 600; }
.arkme-workspace-dialog button:disabled { opacity: .48; cursor: default; }
.arkme-redesign-placeholder { width: 100%; height: 100%; display: grid; place-content: center; justify-items: center; color: #858992; text-align: center; }
.arkme-redesign-placeholder > span { width: 48px; height: 48px; display: grid; place-items: center; border: 1px solid #e1e2e5; border-radius: 14px; color: #555a64; }
.arkme-redesign-placeholder h1 { margin: 16px 0 7px; color: #3e424b; font-size: 18px; }
.arkme-redesign-placeholder p { margin: 0; font-size: 12px; }

/* DSH owns theme state. Keep the light baseline above unchanged and only
   replace redesign colors while the host's dark-theme attribute is active. */
body[data-ds-dark-theme] [data-arkme-workspace] {
  --arkme-line: var(--dsw-alias-border-l1);
  --arkme-muted: var(--dsw-alias-label-tertiary);
  --arkme-soft: var(--dsw-alias-bg-layer-2);
  --arkme-focus: var(--dsw-alias-state-business-primary);
  color: var(--dsw-alias-label-primary);
}

/* The permanent DSH seats use inline layout styles, so their light colors
   need explicit theme-scoped overrides without changing the seat geometry. */
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"],
body[data-ds-dark-theme] [data-arkme-owned="product-navigation"] {
  background: var(--dsw-specific-sidebar-fill) !important;
  color: var(--dsw-alias-label-secondary) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="product-brand"] {
  background: transparent !important;
  box-shadow: none;
}
body[data-ds-dark-theme] [data-arkme-workspace] [data-arkme-theme-image="light"] { display: none !important; }
body[data-ds-dark-theme] [data-arkme-workspace] [data-arkme-theme-image="dark"] { display: block !important; }
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"] > div {
  border-color: var(--dsw-alias-border-l1) !important;
  background: var(--dsw-alias-bg-layer-1) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="persistent-workspace"] {
  background: var(--dsw-alias-bg-base) !important;
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="persistent-workspace"] .arkme-conversation-surface,
body[data-ds-dark-theme] [data-arkme-owned="persistent-workspace"] .arkme-conversation-composer {
  background: var(--dsw-alias-bg-base) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="persistent-workspace"] div:has(> input[aria-label="搜索"]) {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-specific-input-major) !important;
  box-shadow: var(--dsw-shadow-lv2) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="product-navigation"] button:not([data-arkme-feedback]):hover {
  background: var(--dsw-alias-interactive-bg-hover) !important;
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="product-navigation"] button[aria-current="page"] {
  background: var(--dsw-alias-interactive-bg-active) !important;
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] {
  --arkme-directory-accent: var(--dsw-alias-state-business-primary);
}

/* Product conversation directory: its inner workspace owns inline light
   surfaces independently from the persistent DSH seats above. */
body[data-ds-dark-theme] [data-arkme-owned="product-surface"],
body[data-ds-dark-theme] [data-arkme-owned="directory-pane"],
body[data-ds-dark-theme] [data-arkme-owned="directory-pane"] [aria-label="Arkme 会话列表"],
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"] [aria-label="Arkme 会话列表"] {
  background: var(--dsw-alias-bg-base) !important;
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="directory-pane"] label:has(> input[aria-label="搜索对话或消息"]),
body[data-ds-dark-theme] [data-arkme-owned="directory-pane"] button[aria-label="新任务"],
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"] [aria-label="Arkme 会话列表"] [data-arkme-directory-search],
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"] [aria-label="Arkme 会话列表"] button[aria-label="新任务"] {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-specific-input-major) !important;
  color: var(--dsw-alias-label-secondary) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="directory-pane"] [role="treeitem"][aria-selected="true"],
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"] [aria-label="Arkme 会话列表"] [role="treeitem"][aria-selected="true"] {
  background: var(--dsw-alias-interactive-bg-active) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="directory-pane"] [role="status"][aria-label$="个人测试版"],
body[data-ds-dark-theme] [data-arkme-owned="persistent-sidebar"] [aria-label="Arkme 会话列表"] [role="status"][aria-label$="个人测试版"] {
  background: var(--dsw-alias-bg-layer-2) !important;
}
body[data-ds-dark-theme] [data-arkme-owned="product-surface"] .arkme-conversation-composer {
  background: var(--dsw-alias-bg-base) !important;
}

/* Recording keeps the existing buttons and actions; only their inline fills
   are remapped while the DSH dark flag is active. */
body[data-ds-dark-theme] .arkme-redesign-recordings-page [aria-label="全天候录音操作"] > div > button,
body[data-ds-dark-theme] [data-arkme-owned="product-surface"] [aria-label="全天候录音操作"] > div > button {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-alias-button-elevated-fill) !important;
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] .arkme-redesign-recordings-page [aria-label="全天候录音操作"] > div > button:first-child,
body[data-ds-dark-theme] [data-arkme-owned="product-surface"] [aria-label="全天候录音操作"] > div > button:first-child {
  border-color: var(--dsw-alias-button-primary-fill) !important;
  background: var(--dsw-alias-button-primary-fill) !important;
  color: var(--dsw-alias-label-primary-inverted) !important;
}

/* Calendar is portalled to document.body, so it cannot inherit the product
   workspace background. Anchor the dark mapping to its own accessible root. */
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"]) {
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  > div > section[aria-label="客户端日历"],
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  > div > section[aria-label="当天内容"] {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-alias-bg-layer-1) !important;
  color: var(--dsw-alias-label-primary) !important;
  box-shadow: var(--dsw-shadow-lv2) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  > div > section[aria-label="客户端日历"] > span[aria-hidden] {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-alias-bg-layer-1) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] > header button,
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] button[aria-label*="记录"] {
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] > div > span {
  color: var(--dsw-alias-label-tertiary) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] button[data-selected="false"][aria-label*="条记录"] > span:last-child {
  background: transparent !important;
  color: var(--dsw-alias-label-secondary) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] button[data-selected="true"],
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] button[data-selected="true"] > span {
  color: var(--dsw-alias-label-primary-inverted) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="客户端日历"] button[data-selected="true"] > span:last-child {
  background: transparent !important;
  color: var(--dsw-alias-label-primary-inverted) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="当天内容"] article > div > div:last-child {
  border-color: var(--dsw-alias-border-l1) !important;
  background: var(--dsw-alias-bg-layer-2) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="当天内容"] article h3,
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="当天内容"] article p {
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="当天内容"] article time,
body[data-ds-dark-theme] [aria-label="客户端日历"]:has(> button[aria-label="关闭日历"])
  section[aria-label="当天内容"] article span {
  color: var(--dsw-alias-label-secondary) !important;
}

body[data-ds-dark-theme] .arkme-redesign-root,
body[data-ds-dark-theme] .arkme-redesign-chat-panel,
body[data-ds-dark-theme] .arkme-redesign-content,
body[data-ds-dark-theme] .arkme-redesign-feature-page,
body[data-ds-dark-theme] .arkme-redesign-recordings-page,
body[data-ds-dark-theme] .arkme-redesign-plugins-page,
body[data-ds-dark-theme] .arkme-redesign-model-settings,
body[data-ds-dark-theme] .arkme-redesign-details {
  background: var(--dsw-alias-bg-base);
  color: var(--dsw-alias-label-primary);
}

body[data-ds-dark-theme] .arkme-native-desktop .arkme-redesign-root::before {
  background: var(--dsw-alias-border-l1);
}
body[data-ds-dark-theme] .arkme-redesign-rail {
  border-color: var(--dsw-alias-border-l2);
  background: var(--dsw-specific-sidebar-fill);
  box-shadow: var(--dsw-shadow-lv2);
}
body[data-ds-dark-theme] .arkme-redesign-rail-primary button,
body[data-ds-dark-theme] .arkme-redesign-rail-footer > button,
body[data-ds-dark-theme] .arkme-redesign-profile-menu button,
body[data-ds-dark-theme] .arkme-redesign-task-list > button,
body[data-ds-dark-theme] .arkme-redesign-task-first,
body[data-ds-dark-theme] .arkme-workspace-dialog > nav button,
body[data-ds-dark-theme] .arkme-workspace-dialog-back,
body[data-ds-dark-theme] .arkme-redesign-placeholder > span {
  color: var(--dsw-alias-label-secondary);
}
body[data-ds-dark-theme] .arkme-redesign-rail-primary button:not([data-arkme-feedback]):hover,
body[data-ds-dark-theme] .arkme-redesign-rail-footer > button:not([data-arkme-feedback]):hover,
body[data-ds-dark-theme] .arkme-redesign-profile-menu button:not([data-arkme-feedback]):hover,
body[data-ds-dark-theme] .arkme-redesign-chat-search:not([data-arkme-feedback]):hover,
body[data-ds-dark-theme] .arkme-redesign-task-section-title button:hover,
body[data-ds-dark-theme] .arkme-redesign-task-list > button:hover,
body[data-ds-dark-theme] .arkme-redesign-task-first:hover,
body[data-ds-dark-theme] .arkme-extension-toolbar > button:hover,
body[data-ds-dark-theme] button.arkme-redesign-setting-row:not([data-arkme-feedback]):hover,
body[data-ds-dark-theme] a.arkme-redesign-setting-row:hover,
body[data-ds-dark-theme] .arkme-redesign-model-settings > header button:hover,
body[data-ds-dark-theme] .arkme-redesign-round-tool:hover,
body[data-ds-dark-theme] .arkme-workspace-directory-list > button:hover {
  background: var(--dsw-alias-interactive-bg-hover);
  color: var(--dsw-alias-label-primary);
}
body[data-ds-dark-theme] .arkme-redesign-rail-primary button.is-active,
body[data-ds-dark-theme] .arkme-redesign-rail-footer > button.is-active,
body[data-ds-dark-theme] .arkme-redesign-task-list > button.is-selected {
  background: var(--dsw-alias-interactive-bg-active);
  color: var(--dsw-alias-label-primary);
}
body[data-ds-dark-theme] .arkme-redesign-rail-footer,
body[data-ds-dark-theme] .arkme-redesign-profile-menu,
body[data-ds-dark-theme] .arkme-redesign-task-section,
body[data-ds-dark-theme] .arkme-redesign-route-chats .arkme-conversation-header,
body[data-ds-dark-theme] .arkme-redesign-search-page .arkme-search-history button,
body[data-ds-dark-theme] .arkme-redesign-search-page .arkme-search-quick button,
body[data-ds-dark-theme] .arkme-redesign-settings-group h2,
body[data-ds-dark-theme] .arkme-redesign-setting-row,
body[data-ds-dark-theme] .arkme-account-info-row,
body[data-ds-dark-theme] .arkme-redesign-starters > button,
body[data-ds-dark-theme] .arkme-redesign-details,
body[data-ds-dark-theme] .arkme-workspace-dialog > nav,
body[data-ds-dark-theme] .arkme-workspace-dialog > footer {
  border-color: var(--dsw-alias-border-l1) !important;
}
body[data-ds-dark-theme] .arkme-redesign-profile-popover,
body[data-ds-dark-theme] .arkme-workspace-dialog {
  border-color: var(--dsw-alias-border-l2);
  background: var(--dsw-specific-menu);
  box-shadow: var(--dsw-shadow-lv3);
}
body[data-ds-dark-theme] .arkme-redesign-profile-head small,
body[data-ds-dark-theme] .arkme-redesign-profile-menu small,
body[data-ds-dark-theme] .arkme-redesign-profile-menu button > svg:last-child,
body[data-ds-dark-theme] .arkme-redesign-task-section-title,
body[data-ds-dark-theme] .arkme-redesign-task-copy small,
body[data-ds-dark-theme] .arkme-account-profile-qr,
body[data-ds-dark-theme] .arkme-redesign-feature-page > header p,
body[data-ds-dark-theme] .arkme-redesign-feature-page > header span,
body[data-ds-dark-theme] .arkme-redesign-search-page input[aria-label="搜索"]:not(:focus)::placeholder,
body[data-ds-dark-theme] .arkme-redesign-settings-profile p,
body[data-ds-dark-theme] .arkme-redesign-settings-group h2,
body[data-ds-dark-theme] .arkme-redesign-setting-summary,
body[data-ds-dark-theme] .arkme-account-info-copy > small,
body[data-ds-dark-theme] .arkme-account-info-action,
body[data-ds-dark-theme] .arkme-account-info-row > svg,
body[data-ds-dark-theme] .arkme-account-info-icon,
body[data-ds-dark-theme] .arkme-redesign-setting-row > svg,
body[data-ds-dark-theme] .arkme-redesign-hero-input textarea::placeholder,
body[data-ds-dark-theme] .arkme-redesign-starters small,
body[data-ds-dark-theme] .arkme-workspace-dialog > header span,
body[data-ds-dark-theme] .arkme-workspace-dialog > nav > span,
body[data-ds-dark-theme] .arkme-workspace-dialog-status,
body[data-ds-dark-theme] .arkme-workspace-dialog > footer small,
body[data-ds-dark-theme] .arkme-redesign-placeholder {
  color: var(--dsw-alias-label-tertiary);
}

body[data-ds-dark-theme] .arkme-redesign-chat-search,
body[data-ds-dark-theme] .arkme-extension-toolbar label,
body[data-ds-dark-theme] .arkme-extension-toolbar > button,
body[data-ds-dark-theme] .arkme-redesign-settings-group,
body[data-ds-dark-theme] .arkme-redesign-model-settings > header button,
body[data-ds-dark-theme] .arkme-redesign-source-button,
body[data-ds-dark-theme] .arkme-redesign-round-tool,
body[data-ds-dark-theme] .arkme-redesign-starter-icon,
body[data-ds-dark-theme] .arkme-workspace-directory-list > button > span,
body[data-ds-dark-theme] .arkme-redesign-placeholder > span {
  border-color: var(--dsw-alias-border-l2) !important;
}
body[data-ds-dark-theme] .arkme-redesign-chat-search,
body[data-ds-dark-theme] .arkme-extension-toolbar label {
  color: var(--dsw-alias-label-tertiary) !important;
}
body[data-ds-dark-theme] .arkme-extension-toolbar input,
body[data-ds-dark-theme] .arkme-redesign-settings-profile h1,
body[data-ds-dark-theme] .arkme-redesign-model-settings > header button,
body[data-ds-dark-theme] .arkme-redesign-task-start h1,
body[data-ds-dark-theme] .arkme-redesign-hero-input textarea,
body[data-ds-dark-theme] .arkme-redesign-starter-icon,
body[data-ds-dark-theme] .arkme-redesign-placeholder h1 {
  color: var(--dsw-alias-label-primary);
}

body[data-ds-dark-theme] .arkme-redesign-task-list,
body[data-ds-dark-theme] .arkme-redesign-model-settings > header button,
body[data-ds-dark-theme] .arkme-redesign-plugins-page .arkme-extension-card {
  background: var(--dsw-alias-bg-layer-1) !important;
}
body[data-ds-dark-theme] .arkme-redesign-settings-surface,
body[data-ds-dark-theme] .arkme-redesign-settings-group {
  color: var(--dsw-alias-label-primary);
  background: transparent !important;
}
body[data-ds-dark-theme] .arkme-account-dialog {
  border-color: var(--dsw-alias-border-l2);
  background: var(--dsw-specific-menu);
  color: var(--dsw-alias-label-primary);
  box-shadow: var(--dsw-shadow-lv3);
}
body[data-ds-dark-theme] .arkme-account-dialog > header,
body[data-ds-dark-theme] .arkme-account-qr-card {
  border-color: var(--dsw-alias-border-l1);
}
body[data-ds-dark-theme] .arkme-account-qr-card,
body[data-ds-dark-theme] .arkme-account-form input,
body[data-ds-dark-theme] .arkme-account-code-row button,
body[data-ds-dark-theme] .arkme-account-dialog-actions button {
  background: var(--dsw-alias-bg-layer-1);
  color: var(--dsw-alias-label-primary);
  border-color: var(--dsw-alias-border-l2);
}
body[data-ds-dark-theme] .arkme-account-dialog-actions button[type="submit"],
body[data-ds-dark-theme] .arkme-account-dialog-actions button:last-child {
  border-color: var(--dsw-alias-label-primary);
  background: var(--dsw-alias-label-primary);
  color: var(--dsw-alias-bg-base);
}
body[data-ds-dark-theme] .arkme-account-rule,
body[data-ds-dark-theme] .arkme-account-qr-card span,
body[data-ds-dark-theme] .arkme-account-qr-card small,
body[data-ds-dark-theme] .arkme-account-form label {
  color: var(--dsw-alias-label-tertiary);
}
body[data-ds-dark-theme] .arkme-redesign-route-chats .arkme-conversation-surface,
body[data-ds-dark-theme] .arkme-redesign-plugins-page .arkme-extension-center-embedded > section {
  background: var(--dsw-alias-bg-base) !important;
}
body[data-ds-dark-theme] .arkme-redesign-route-chats .arkme-conversation-composer-inner,
body[data-ds-dark-theme] .arkme-redesign-search-page .arkme-search-box {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-specific-input-major) !important;
  color: var(--dsw-alias-label-primary) !important;
  box-shadow: var(--dsw-shadow-lv2) !important;
}
body[data-ds-dark-theme] .arkme-conversation-composer-inner[data-arkme-primary-composer="true"] {
  --arkme-primary-composer-idle: #151515;
  --arkme-primary-composer-focused: #000000;
  background: var(--arkme-primary-composer-idle, #f6f6f6) !important;
  box-shadow: none !important;
}
body[data-ds-dark-theme] .arkme-conversation-composer-inner[data-arkme-primary-composer="true"][data-arkme-composer-focused="true"] {
  background: var(--arkme-primary-composer-focused, #ffffff) !important;
}
body[data-ds-dark-theme] .arkme-redesign-task-greeting img {
  filter: invert(1) hue-rotate(180deg);
}
body[data-ds-dark-theme] .arkme-redesign-hero-input {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-specific-input-major) !important;
  color: var(--dsw-alias-label-primary) !important;
  box-shadow: var(--dsw-shadow-lv2) !important;
}
body[data-ds-dark-theme] .arkme-redesign-hero-input textarea {
  background: transparent !important;
}
body[data-ds-dark-theme] .arkme-redesign-source-button,
body[data-ds-dark-theme] .arkme-redesign-round-tool,
body[data-ds-dark-theme] .arkme-redesign-starter-icon {
  background: var(--dsw-alias-button-elevated-fill) !important;
}
body[data-ds-dark-theme] .arkme-redesign-search-page .arkme-search-history button,
body[data-ds-dark-theme] .arkme-redesign-search-page .arkme-search-quick button {
  color: var(--dsw-alias-label-primary) !important;
}
body[data-ds-dark-theme] .arkme-redesign-plugins-page .arkme-extension-card {
  border-color: var(--dsw-alias-border-l1) !important;
}
body[data-ds-dark-theme] .arkme-redesign-plugins-page .arkme-extension-card:hover {
  border-color: var(--dsw-alias-border-l2) !important;
  background: var(--dsw-alias-interactive-bg-hover) !important;
}
body[data-ds-dark-theme] .arkme-redesign-task-section:focus-within .arkme-redesign-task-list {
  box-shadow: var(--dsw-shadow-lv2);
}

body[data-ds-dark-theme] .arkme-redesign-settings-error {
  background: var(--dsw-alias-interactive-bg-hover-danger);
  color: var(--dsw-alias-state-error-primary);
}
body[data-ds-dark-theme] .arkme-remote-page-header h1,
body[data-ds-dark-theme] .arkme-remote-section-header h2,
body[data-ds-dark-theme] .arkme-remote-allow-row strong,
body[data-ds-dark-theme] .arkme-remote-device-row strong,
body[data-ds-dark-theme] .arkme-remote-name-row strong,
body[data-ds-dark-theme] .arkme-remote-dialog,
body[data-ds-dark-theme] .arkme-remote-pairing-code { color: var(--dsw-alias-label-primary); }
body[data-ds-dark-theme] .arkme-remote-section-header p,
body[data-ds-dark-theme] .arkme-remote-page-header p,
body[data-ds-dark-theme] .arkme-remote-allow-row span,
body[data-ds-dark-theme] .arkme-remote-device-row span,
body[data-ds-dark-theme] .arkme-remote-name-row small,
body[data-ds-dark-theme] .arkme-remote-dialog header p,
body[data-ds-dark-theme] .arkme-remote-pairing-display > p,
body[data-ds-dark-theme] .arkme-remote-dialog-note,
body[data-ds-dark-theme] .arkme-remote-empty-row { color: var(--dsw-alias-label-tertiary); }
body[data-ds-dark-theme] .arkme-remote-settings-card,
body[data-ds-dark-theme] .arkme-remote-settings-dialog,
body[data-ds-dark-theme] .arkme-remote-dialog,
body[data-ds-dark-theme] .arkme-remote-pairing-display,
body[data-ds-dark-theme] .arkme-remote-rename input { border-color: var(--dsw-alias-border-l2); background: var(--dsw-alias-bg-layer-1); color: var(--dsw-alias-label-primary); }
body[data-ds-dark-theme] .arkme-remote-allow-row,
body[data-ds-dark-theme] .arkme-remote-device-row,
body[data-ds-dark-theme] .arkme-remote-rename,
body[data-ds-dark-theme] .arkme-remote-page-header { border-color: var(--dsw-alias-border-l1); }
body[data-ds-dark-theme] .arkme-remote-settings-close,
body[data-ds-dark-theme] .arkme-remote-icon-button,
body[data-ds-dark-theme] .arkme-remote-dialog-close,
body[data-ds-dark-theme] .arkme-remote-pairing-tools button,
body[data-ds-dark-theme] .arkme-remote-name-row { color: var(--dsw-alias-label-secondary); }
body[data-ds-dark-theme] .arkme-remote-settings-close:hover,
body[data-ds-dark-theme] .arkme-remote-icon-button:hover,
body[data-ds-dark-theme] .arkme-remote-dialog-close:hover,
body[data-ds-dark-theme] .arkme-remote-pairing-tools button:hover,
body[data-ds-dark-theme] .arkme-remote-name-row:hover { background: var(--dsw-alias-interactive-bg-hover); color: var(--dsw-alias-label-primary); }
body[data-ds-dark-theme] .arkme-remote-add-button,
body[data-ds-dark-theme] .arkme-remote-rename button[type="submit"],
body[data-ds-dark-theme] .arkme-remote-pairing-expired button { background: var(--dsw-alias-button-primary-fill); color: var(--dsw-alias-label-primary-inverted); }
body[data-ds-dark-theme] .arkme-remote-device-row > button,
body[data-ds-dark-theme] .arkme-remote-rename button { border-color: var(--dsw-alias-border-l2); background: var(--dsw-alias-button-elevated-fill); color: var(--dsw-alias-label-secondary); }
body[data-ds-dark-theme] .arkme-remote-switch[aria-checked="true"] { background: var(--dsw-alias-state-business-primary); }
body[data-ds-dark-theme] .arkme-remote-pairing-tabs { background: var(--dsw-alias-bg-layer-2); }
body[data-ds-dark-theme] .arkme-remote-pairing-tabs button { color: var(--dsw-alias-label-tertiary); }
body[data-ds-dark-theme] .arkme-remote-pairing-tabs button[aria-selected="true"] { background: var(--dsw-alias-button-elevated-fill); color: var(--dsw-alias-label-primary); }
body[data-ds-dark-theme] .arkme-remote-settings-dialog-backdrop,
body[data-ds-dark-theme] .arkme-remote-dialog-backdrop { background: rgba(7, 9, 13, .56); }
body[data-ds-dark-theme] .arkme-redesign-setting-row > strong.is-danger,
body[data-ds-dark-theme] .arkme-redesign-task-error,
body[data-ds-dark-theme] .arkme-workspace-dialog-error {
  color: var(--dsw-alias-state-error-primary);
}
body[data-ds-dark-theme] .arkme-redesign-task-state.is-complete > i {
  background: var(--dsw-alias-state-success-tertiary);
}
body[data-ds-dark-theme] .arkme-redesign-task-state.is-complete > i::after {
  background: var(--dsw-alias-state-success-primary);
}
body[data-ds-dark-theme] .arkme-redesign-task-matrix i {
  background: var(--dsw-alias-state-business-primary);
}
body[data-ds-dark-theme] .arkme-redesign-hero-input:focus-within {
  border-color: var(--dsw-alias-state-business-primary);
  box-shadow: 0 0 0 3px var(--dsw-alias-state-business-tertiary);
}
body[data-ds-dark-theme] .arkme-redesign-starters > button:hover strong {
  color: var(--dsw-alias-state-business-primary);
}
body[data-ds-dark-theme] .arkme-redesign-send-task,
body[data-ds-dark-theme] .arkme-workspace-dialog > footer > div > button {
  background: var(--dsw-alias-button-primary-fill) !important;
  color: var(--dsw-alias-label-primary-inverted) !important;
}
body[data-ds-dark-theme] .arkme-redesign-send-task:disabled {
  background: var(--dsw-alias-button-elevated-fill) !important;
  color: var(--dsw-alias-label-secondary) !important;
}
body[data-ds-dark-theme] .arkme-workspace-dialog-backdrop {
  background: var(--dsw-alias-bg-mask-1);
}

@media (max-width: 1024px) {
  .arkme-redesign-chat-panel { left: 82px; width: 264px; }
  .arkme-redesign-content { left: 82px; }
  .arkme-redesign-content.has-panel { left: 346px; }
  .arkme-redesign-rail { left: 12px; }
  .arkme-redesign-starters > button { padding: 0 10px; }
  .arkme-redesign-feature-page { padding-left: 30px; padding-right: 30px; }
}

@media (max-width: 820px) {
  .arkme-redesign-chat-panel { display: none; }
  .arkme-redesign-content.has-panel { left: 82px; }
  .arkme-redesign-task-start { padding: 28px; }
  .arkme-redesign-starters { grid-template-columns: 1fr; gap: 6px; }
  .arkme-redesign-starters > button { border-right: 0; }
  .arkme-voiceprint-relationships { grid-template-columns: minmax(0, 1fr) !important; gap: 28px !important; }
  .arkme-voiceprint-outbound { padding-left: 0 !important; padding-top: 28px !important; border-left: 0 !important; border-top: 1px solid var(--dsw-alias-border-subtle, #e6e7eb) !important; }
}

@media (prefers-reduced-motion: reduce) {
  .arkme-redesign-task-matrix i { animation: none; opacity: .6; }
}

/* Contacts is a sibling product mode: it owns either persistent seat, never
   markup inside the conversation directory. */
.arkme-contact-directory, .arkme-directory-detail-pane {
  min-width: 0; min-height: 0; height: 100%; overflow: hidden;
  box-sizing: border-box; color: var(--dsw-alias-label-primary, #202124); font-size: 13px;
}
[data-arkme-directory-mode="contacts"] {
  background: var(--dsw-alias-bg-base, #fff) !important;
  border-left-color: var(--dsw-alias-border-l1, #ececef) !important;
}
.arkme-contact-directory { --arkme-contact-directory-header-fill: var(--dsw-alias-bg-base, #fff); padding: 0 6px 18px; overflow-y: auto; overflow-wrap: anywhere; }
.arkme-contact-directory-surface {
  display: flex; flex-direction: column; min-width: 0; min-height: 0; height: 100%;
  color: var(--dsw-alias-label-primary, #202124); background: var(--dsw-alias-bg-base, #fff);
}
.arkme-contact-directory-surface > .arkme-contact-directory { flex: 1; height: auto; }
.arkme-contact-directory-toolbar {
  position: relative; flex: none; min-width: 0; display: flex; align-items: center;
  gap: 8px; margin: 24px 16px 16px; -webkit-app-region: no-drag;
}
.arkme-contact-directory-search-field {
  display: flex; align-items: center; flex: 1; min-width: 0; height: 40px; gap: 8px; padding: 0 11px;
  box-sizing: border-box; border: 1px solid var(--dsw-alias-border-l2, #e2e3e6); border-radius: 11px;
  background: var(--dsw-specific-input-major, #fff); color: var(--dsw-alias-label-tertiary, #92959e);
}
.arkme-contact-directory-search-field > svg { flex: none; }
.arkme-contact-directory-search-field input {
  width: 100%; min-width: 0; padding: 0; border: 0; outline: 0; background: transparent;
  color: var(--dsw-alias-label-primary, #202124); font: inherit; font-size: 12px;
}
.arkme-directory-search-toolbar input::placeholder { color: var(--dsw-alias-label-tertiary, #92959e); }
.arkme-contact-directory-search-field:focus-within { outline: 2px solid var(--arkme-focus); outline-offset: 2px; }
.arkme-contact-directory-search-field button {
  flex: none; display: grid; place-items: center; width: 20px; height: 28px; padding: 0; border: 0;
  border-radius: 6px; background: transparent; color: inherit; cursor: pointer;
}
.arkme-contact-directory-search-field button:not([data-arkme-feedback]):hover { background: var(--dsw-alias-interactive-bg-hover, #f6f6f7); }
.arkme-directory-search-toolbar button[title="添加"] {
  background: var(--dsw-specific-input-major, #fff) !important;
  border-color: var(--dsw-alias-border-l2, #e2e3e6) !important;
  color: var(--dsw-alias-label-secondary, #555a64) !important;
}
.arkme-contact-directory-toolbar button:focus-visible { outline: 2px solid var(--arkme-focus); outline-offset: 2px; }
body[data-ds-dark-theme] .arkme-contact-directory-surface { background: var(--dsw-alias-bg-base); }
.arkme-directory-detail-pane { overflow: hidden; }
.arkme-contact-directory button, .arkme-directory-detail-pane button {
  appearance: none; box-sizing: border-box; margin: 0; border: 0; font: inherit; color: inherit;
}
.arkme-contact-directory-section { min-width: 0; padding: 2px 0 5px; border-bottom: 1px solid var(--dsw-alias-border-l1, var(--arkme-line)); }
/* Keep the initial inset on the first section so sticky headers reach the scrollport top. */
.arkme-contact-directory-section:first-child { padding-top: 10px; }
.arkme-contact-directory-section-header {
  width: 100%; min-width: 0; min-height: 42px; display: flex; align-items: center; justify-content: space-between;
  gap: 8px; padding: 0 10px; border-radius: 10px; background: transparent; text-align: left; cursor: pointer;
}
/* The section bounds release its header before the next section takes over. */
.arkme-contact-directory-section-header[aria-expanded="true"] {
  position: sticky; top: 0; z-index: 1;
}
/* A square opaque base covers scrolling rows; the separate hover layer stays rounded. */
.arkme-contact-directory-section-header[aria-expanded="true"]::before,
.arkme-contact-directory-section-header[aria-expanded="true"]::after {
  content: ""; position: absolute; inset: 0; pointer-events: none; z-index: -1;
}
.arkme-contact-directory-section-header[aria-expanded="true"]::before { background: var(--arkme-contact-directory-header-fill); }
.arkme-contact-directory-section-header[aria-expanded="true"]::after { border-radius: inherit; }
.arkme-contact-directory-section-title { min-width: 0; display: flex; align-items: center; gap: 6px; }
.arkme-contact-directory-section-title strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 13px; font-weight: 650; }
.arkme-contact-directory-caret {
  width: 14px; flex: none; color: var(--dsw-alias-label-tertiary, var(--arkme-muted));
  font-size: 18px; line-height: 1; text-align: center; transform-origin: center; transition: transform 160ms ease;
}
.arkme-contact-directory-section-header[aria-expanded="true"] .arkme-contact-directory-caret { transform: rotate(90deg); }
.arkme-contact-directory-section-header:hover { background: var(--dsw-alias-interactive-bg-hover, #f6f6f7); }
.arkme-contact-directory-section-header[aria-expanded="true"]:hover::after { background: var(--dsw-alias-interactive-bg-hover-solid, var(--arkme-contact-directory-header-fill)); }
.arkme-contact-directory-section-body { min-width: 0; padding: 0 0 5px; }
.arkme-contact-directory-list { display: grid; gap: 1px; min-width: 0; }
.arkme-contact-directory-count { flex: none; color: var(--dsw-alias-label-tertiary, var(--arkme-muted)); font-size: 11px; font-variant-numeric: tabular-nums; }
.arkme-contact-directory-row {
  width: 100%; min-width: 0; min-height: 52px; display: flex; align-items: center; gap: 10px;
  margin: 1px 0; padding: 7px 10px; overflow: hidden; border-radius: 13px; background: transparent;
  text-align: left; cursor: pointer;
}
.arkme-contact-directory-row img { width: 38px; height: 38px; flex: none; border-radius: 50%; object-fit: cover; }
.arkme-contact-directory-row.is-static { cursor: default; }
.arkme-contact-directory-row.is-selected { background: var(--dsw-alias-interactive-bg-active, #eef0f4); }
.arkme-contact-directory-row:not(.is-static):hover { background: var(--dsw-alias-interactive-bg-hover, #f6f6f7); }
.arkme-contact-directory-avatar { width: 38px; height: 38px; flex: none; display: grid; place-items: center; overflow: hidden; border-radius: 50%; }
.arkme-contact-directory-row-copy { min-width: 0; flex: 1; display: grid; align-content: center; overflow: hidden; }
.arkme-contact-directory-row-copy strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 13px; line-height: 18px; font-weight: 600; }
.arkme-contact-directory-row-copy small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--dsw-alias-label-secondary, #68707c); font-size: 11px; line-height: 16px; }
.arkme-contact-directory-letter { padding: 8px 10px 2px; color: var(--dsw-alias-label-tertiary, var(--arkme-muted)); font-size: 11px; line-height: 16px; font-weight: 600; }
.arkme-contact-directory-alphabetical, .arkme-contact-directory-letter-group { min-width: 0; }
.arkme-contact-directory-status, .arkme-contact-directory-warning { margin: 3px 8px; padding: 7px 9px; color: var(--dsw-alias-label-secondary, var(--arkme-muted)); font-size: 11px; line-height: 16px; overflow-wrap: anywhere; }
.arkme-contact-directory-warning { display: flex; align-items: center; justify-content: space-between; gap: 8px; color: var(--dsw-alias-state-warning-primary, #b45309); background: var(--dsw-alias-state-warning-tertiary, #fff7ed); border-radius: 9px; }
.arkme-contact-directory-warning button { flex: none; padding: 2px 4px; color: inherit; background: transparent; cursor: pointer; font-weight: 600; }
.arkme-contact-directory-more { width: calc(100% - 16px); min-height: 32px; margin: 3px 8px !important; padding: 6px 8px; border-radius: 9px; background: transparent; color: var(--dsw-alias-state-business-primary, #4f5fbf) !important; text-align: center; cursor: pointer; }
.arkme-contact-directory-empty { padding: 14px 12px; color: var(--dsw-alias-label-tertiary, var(--arkme-muted)); font-size: 12px; line-height: 18px; text-align: center; }
.arkme-directory-detail-empty { min-width: 0; min-height: 0; height: 100%; display: grid; place-items: center; background: var(--dsw-alias-bg-base, #fff); }
.arkme-directory-detail-logo { width: 96px; height: 96px; object-fit: contain; opacity: .9; }
.arkme-contact-detail, .arkme-contact-profile, .arkme-unmarked-speaker-summary, .arkme-unmarked-speaker-audio, .arkme-unmarked-speaker-choice { min-width: 0; overflow-wrap: anywhere; }
.arkme-contact-detail { min-width: 0; min-height: 0; height: 100%; box-sizing: border-box; overflow-y: auto; background: var(--dsw-alias-bg-base, #fff); padding: clamp(32px, 6vh, 72px) clamp(20px, 5vw, 60px); }
.arkme-contact-profile { width: min(100%, 600px); min-width: 0; margin: 0 auto; }
.arkme-contact-profile-main { display: grid; grid-template-columns: 72px minmax(0, 1fr); align-items: start; gap: 24px; padding-bottom: 30px; }
/* Harness applies superellipse corners globally; avatar silhouettes stay circular. */
[data-arkme-avatar], [data-arkme-avatar] *, .arkme-contact-profile-avatar { corner-shape: round; }
.arkme-contact-profile-avatar { width: 72px; height: 72px; display: grid; place-items: center; overflow: hidden; border-radius: 50%; }
.arkme-contact-profile-identity { min-width: 0; display: grid; gap: 10px; }
.arkme-contact-profile-name { margin: 0; color: var(--dsw-alias-label-primary, #17191c); overflow-wrap: anywhere; font-size: 22px; line-height: 30px; font-weight: 600; }
.arkme-contact-profile-fields { display: grid; gap: 5px; margin: 0; }
.arkme-contact-profile-fields > div { min-width: 0; display: grid; grid-template-columns: 48px minmax(0, 1fr); gap: 10px; font-size: 13px; line-height: 20px; }
.arkme-contact-profile-fields dt, .arkme-contact-profile-row dt { color: var(--dsw-alias-label-secondary, #68707c); }
.arkme-contact-profile-fields dt, .arkme-contact-profile-fields dd, .arkme-contact-profile-row dt, .arkme-contact-profile-row dd { margin: 0; min-width: 0; overflow-wrap: anywhere; }
.arkme-contact-profile-fields dd, .arkme-contact-profile-row dd { color: var(--dsw-alias-label-primary, #17191c); }
.arkme-contact-profile-section { padding: 24px 0; border-top: 1px solid var(--dsw-alias-border-l1, var(--arkme-line)); }
.arkme-contact-profile-section-title { margin: 0 0 16px; color: var(--dsw-alias-label-secondary, #68707c); font-size: 14px; line-height: 22px; font-weight: 500; }
.arkme-contact-profile-row { display: grid; grid-template-columns: 76px minmax(0, 1fr); gap: 18px; margin: 0; font-size: 14px; line-height: 22px; }
.arkme-contact-profile-remark { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; }
.arkme-contact-profile-remark > span { min-width: 0; }
.arkme-contact-profile-remark .arkme-contact-remark-edit { display: inline-flex; align-items: center; gap: 5px; flex: none; margin: -4px -6px -4px 0; padding: 4px 6px; border: 0; border-radius: 6px; background: transparent; color: var(--dsw-alias-state-business-primary, #4f5fbf); font: inherit; font-size: 13px; line-height: 22px; cursor: pointer; }
.arkme-contact-remark-edit:not([data-arkme-feedback]):hover { background: var(--dsw-alias-interactive-bg-hover, #f3f4f6); }
.arkme-contact-remark-backdrop { position: fixed; inset: 0; z-index: 10300; display: grid; place-items: center; padding: 16px; box-sizing: border-box; background: var(--dsw-alias-bg-mask-1, rgba(19, 22, 26, .34)); backdrop-filter: blur(2px); font-family: inherit; }
.arkme-contact-remark-dialog { width: min(440px, 100%); max-height: calc(100dvh - 32px); overflow-y: auto; box-sizing: border-box; margin: 0; padding: 24px; border: 1px solid var(--dsw-alias-border-l2, #e5e7eb); border-radius: 14px; background: var(--dsw-alias-bg-base, #fff); color: var(--dsw-alias-label-primary, #17191c); box-shadow: var(--dsw-shadow-lv2, 0 12px 40px rgba(0, 0, 0, .16)); }
.arkme-contact-remark-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 24px; }
.arkme-contact-remark-header h2 { margin: 0; font-size: 18px; line-height: 26px; font-weight: 600; }
.arkme-contact-remark-dialog button { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; box-sizing: border-box; border: 1px solid var(--dsw-alias-border-l2, #e5e7eb); border-radius: 8px; font: inherit; font-size: 13px; cursor: pointer; }
.arkme-contact-remark-dialog .arkme-contact-remark-close { width: 30px; min-height: 30px; padding: 0; margin: -4px -4px -4px 0; border: 0; background: transparent; color: var(--dsw-alias-label-secondary, #68707c); }
.arkme-contact-remark-label { display: block; margin-bottom: 9px; color: var(--dsw-alias-label-secondary, #68707c); font-size: 13px; line-height: 20px; }
.arkme-contact-remark-input { display: block; width: 100%; min-width: 0; height: 42px; box-sizing: border-box; border: 1px solid var(--dsw-alias-border-l2, #e5e7eb); border-radius: 8px; padding: 0 12px; background: var(--dsw-specific-input-major, var(--dsw-alias-bg-layer-1, #f8f9fa)); color: var(--dsw-alias-label-primary, #17191c); font: inherit; font-size: 14px; }
.arkme-contact-remark-input::placeholder { color: var(--dsw-alias-label-tertiary, #9097a1); }
.arkme-contact-remark-input:focus, .arkme-contact-remark-dialog button:focus-visible, .arkme-contact-remark-edit:focus-visible { outline: 2px solid var(--dsw-alias-state-business-primary, #8295e8); outline-offset: 2px; }
.arkme-contact-remark-footer { display: flex; justify-content: flex-end; gap: 10px; margin-top: 26px; }
.arkme-contact-remark-cancel { min-width: 76px; padding: 0 18px; background: var(--dsw-alias-button-elevated-fill, var(--dsw-specific-input-major, #f8f9fa)); color: var(--dsw-alias-label-primary, #17191c); }
.arkme-contact-remark-dialog .arkme-contact-remark-confirm { min-width: 84px; padding: 0 18px; border-color: transparent; background: var(--dsw-alias-state-business-primary, #4f5fbf); color: var(--dsw-alias-label-primary-inverted, #fff); }
.arkme-contact-remark-dialog button:not([data-arkme-feedback]):hover:not(:disabled) { filter: brightness(.96); }
.arkme-contact-remark-dialog button:disabled, .arkme-contact-remark-input:disabled { opacity: .55; cursor: default; }
.arkme-contact-remark-error { margin: 10px 0 0; color: var(--dsw-alias-state-error-primary, #b42318); font-size: 13px; line-height: 20px; overflow-wrap: anywhere; }
.arkme-contact-profile-actions { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; padding: 26px 0 0; border-top: 1px solid var(--dsw-alias-border-l1, var(--arkme-line)); }
.arkme-contact-profile-actions .arkme-contact-profile-action { min-width: 0; min-height: 78px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; border: 0; border-radius: 8px; padding: 10px 2px; background: transparent; color: var(--dsw-alias-state-business-primary, #4f5fbf) !important; font: inherit; font-size: 14px; line-height: 22px; cursor: pointer; }
.arkme-contact-profile-actions .arkme-contact-profile-action:not([data-arkme-feedback]):hover:not(:disabled) { background: var(--dsw-alias-interactive-bg-hover, #f3f4f6); }
.arkme-contact-profile-actions .arkme-contact-profile-action:disabled { opacity: .5; cursor: default; }
.arkme-contact-profile-action svg { flex: none; }
.arkme-contact-profile-error, .arkme-contact-profile-message-error { color: var(--dsw-alias-state-error-primary, #b42318); font-size: 13px; line-height: 20px; overflow-wrap: anywhere; }
.arkme-contact-profile-message-error { margin-top: 12px; text-align: center; }
.arkme-contact-profile-error { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 14px; margin-bottom: 24px; border-radius: 8px; background: var(--dsw-alias-state-error-tertiary, #fff1f0); }
.arkme-contact-profile-status { padding: 24px 0; color: var(--dsw-alias-label-secondary, var(--arkme-muted)); font-size: 13px; }
.arkme-team-detail {
  min-width: 0; min-height: 0; height: 100%; display: grid; grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden; background: var(--dsw-alias-bg-base, #fff);
}
.arkme-team-detail-header {
  min-width: 0; padding: 32px clamp(24px, 5vw, 56px); border-bottom: 1px solid var(--dsw-alias-border-l1, var(--arkme-line));
}
.arkme-team-detail-header-main {
  width: min(100%, 760px); min-width: 0; display: grid; grid-template-columns: 72px minmax(0, 1fr) auto;
  align-items: center; gap: 18px; margin: 0 auto;
}
.arkme-team-detail-glyph {
  width: 72px; height: 72px; display: grid; place-items: center; border-radius: 20px;
  background: var(--dsw-alias-state-business-tertiary, #eef0ff); color: var(--dsw-alias-state-business-primary, #4f5fbf);
  font-size: 20px; line-height: 1; font-weight: 700;
}
.arkme-team-detail-summary { min-width: 0; display: grid; gap: 7px; }
.arkme-team-detail-header h1 {
  margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 20px; line-height: 28px;
  font-weight: 650; letter-spacing: -.02em;
}
.arkme-team-detail-meta { min-width: 0; display: flex; align-items: center; flex-wrap: wrap; gap: 7px; }
.arkme-team-detail-public-id {
  max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  color: var(--dsw-alias-label-secondary, #68707c); font-size: 12px; line-height: 20px;
}
.arkme-team-role-badge, .arkme-team-member-role {
  flex: none; border-radius: 999px; background: var(--dsw-alias-bg-layer-2, #f2f3f5);
  color: var(--dsw-alias-label-secondary, #68707c); font-size: 11px; line-height: 20px; font-weight: 600;
}
.arkme-team-role-badge { padding: 0 8px; }
.arkme-team-detail-count { min-width: 58px; display: grid; justify-items: end; gap: 1px; color: var(--dsw-alias-label-secondary, #68707c); }
.arkme-team-detail-count strong { color: var(--dsw-alias-label-primary, #202124); font-size: 21px; line-height: 24px; font-weight: 680; font-variant-numeric: tabular-nums; }
.arkme-team-detail-count span { font-size: 11px; line-height: 16px; }
.arkme-team-members {
  min-width: 0; min-height: 0; box-sizing: border-box; padding: 22px clamp(24px, 5vw, 56px) 32px;
  overflow-y: auto; background: var(--dsw-alias-bg-subtle, #f7f7f8);
}
.arkme-team-members-container { width: min(100%, 760px); min-width: 0; margin: 0 auto; }
.arkme-team-members h2 { margin: 0 0 13px; font-size: 15px; line-height: 22px; font-weight: 650; }
.arkme-team-member-list {
  min-width: 0; overflow: hidden; border: 1px solid var(--dsw-alias-border-l1, var(--arkme-line));
  border-radius: 14px; background: var(--dsw-alias-bg-layer-1, #fff); box-shadow: 0 8px 24px rgba(22, 27, 35, .035);
}
.arkme-team-member-row {
  min-width: 0; min-height: 64px; box-sizing: border-box; display: grid; grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center; gap: 12px; padding: 11px 14px; border-bottom: 1px solid var(--dsw-alias-border-l1, var(--arkme-line));
}
.arkme-team-member-row:not(:has(~ .arkme-team-member-row)) { border-bottom: 0; }
.arkme-team-member-avatar { width: 40px; height: 40px; display: grid; place-items: center; overflow: hidden; border-radius: 50%; }
.arkme-team-member-copy { min-width: 0; display: grid; gap: 2px; }
.arkme-team-member-copy strong, .arkme-team-member-copy small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.arkme-team-member-copy strong { font-size: 14px; line-height: 20px; font-weight: 620; }
.arkme-team-member-copy small { color: var(--dsw-alias-label-secondary, #68707c); font-size: 12px; line-height: 17px; }
.arkme-team-member-role { padding: 0 9px; }
.arkme-team-role-badge[data-team-role="owner"], .arkme-team-role-badge[data-team-role="admin"],
.arkme-team-member-role[data-team-member-role="owner"], .arkme-team-member-role[data-team-member-role="admin"] {
  background: var(--dsw-alias-state-business-tertiary, #eef0ff); color: var(--dsw-alias-state-business-primary, #4f5fbf);
}
.arkme-team-detail-status { min-height: 100%; display: flex; align-items: center; justify-content: center; gap: 12px; color: var(--dsw-alias-label-secondary, #68707c); }
.arkme-team-detail-status.is-error, .arkme-team-member-more-error { color: var(--dsw-alias-state-error-primary, #b42318); }
.arkme-team-detail-status button, .arkme-team-member-more { min-height: 34px; padding: 0 12px; border: 1px solid var(--dsw-alias-border-l2, var(--arkme-line)); border-radius: 9px; background: var(--dsw-alias-button-elevated-fill, #fff); cursor: pointer; }
.arkme-team-member-more { width: calc(100% - 24px); margin: 12px !important; color: var(--dsw-alias-state-business-primary, #4f5fbf) !important; }
.arkme-team-member-more:disabled { opacity: .55; cursor: default; }
.arkme-team-member-more-error { padding: 12px 14px 0; font-size: 12px; }
.arkme-contact-world { display: grid; grid-template-columns: 76px minmax(0, 1fr); gap: 18px; padding: 24px 0; border-top: 1px solid var(--dsw-alias-border-l1, var(--arkme-line)); }
.arkme-contact-world-title { margin: 0; color: var(--dsw-alias-label-secondary, #68707c); font-size: 14px; line-height: 22px; font-weight: 400; }
.arkme-contact-world { position: relative; padding-right: 28px; }
.arkme-contact-world-open { position: absolute; inset: 0; z-index: 1; display: flex; align-items: center; justify-content: flex-end; width: 100%; padding: 0; border: 0; border-radius: 4px; background: transparent; color: var(--dsw-alias-label-secondary, #68707c); cursor: pointer; }
.arkme-contact-world:has(.arkme-contact-world-open:hover) { background: var(--arkme-control-hover-surface, #f1f2f6); border-radius: 8px; }
.arkme-contact-world-open:hover { background: transparent; }
.arkme-contact-world-open:focus-visible { outline: 2px solid var(--dsw-alias-state-business-primary, #4778f5); outline-offset: 3px; }
.arkme-contact-world-error button { position: relative; z-index: 2; }
.arkme-contact-world-content, .arkme-contact-world-summary { min-width: 0; }
.arkme-contact-world-preview { min-width: 0; display: flex; align-items: flex-start; gap: 12px; }
.arkme-contact-world-thumbnail { width: 56px; height: 56px; flex: none; overflow: hidden; border-radius: 4px; }
.arkme-contact-world-image { display: block; width: 100%; height: 100%; object-fit: cover; }
.arkme-contact-world-image-error, .arkme-contact-world-image-loading { width: 100%; height: 100%; display: grid; place-items: center; background: var(--dsw-alias-bg-layer-2, var(--arkme-soft)); color: var(--dsw-alias-label-secondary, var(--arkme-muted)); font-size: 11px; line-height: 16px; text-align: center; }
.arkme-contact-world-headline, .arkme-contact-world-text { margin: 0; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; overflow-wrap: anywhere; color: var(--dsw-alias-label-primary, #17191c); font-size: 14px; line-height: 22px; font-weight: 400; }
.arkme-contact-world-headline { -webkit-line-clamp: 1; font-weight: 500; }
.arkme-contact-world-time { display: block; margin-top: 5px; color: var(--dsw-alias-label-secondary, var(--arkme-muted)); font-size: 12px; line-height: 18px; }
.arkme-contact-world-empty, .arkme-contact-world-page-empty, .arkme-contact-world-status { color: var(--dsw-alias-label-secondary, var(--arkme-muted)); font-size: 13px; line-height: 22px; }
.arkme-contact-world-error { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; color: var(--dsw-alias-state-error-primary, #b42318); font-size: 13px; line-height: 22px; margin-bottom: 8px; }

.arkme-directory-unmarked-speaker-detail { min-height: 0; padding: clamp(28px, 5vw, 60px); overflow-y: auto; background: var(--dsw-alias-bg-base, #fff); }
.arkme-unmarked-speaker-token-avatar {
  flex: none; display: grid; place-items: center; border-radius: 50%; background: var(--dsw-alias-bg-module-platform, var(--dsw-alias-bg-layer-1, #f1f2f3));
  color: var(--dsw-alias-label-secondary, #666c75); font-weight: 650; letter-spacing: -.02em; line-height: 1;
}
.arkme-unmarked-speaker-summary {
  width: min(100%, 720px); box-sizing: border-box; display: grid; gap: 18px; margin: 0 auto; padding: 4px 0 24px;
  border: 0; background: transparent;
}
.arkme-unmarked-speaker-summary h1, .arkme-unmarked-speaker-summary h2, .arkme-unmarked-speaker-audio h2, .arkme-unmarked-speaker-choice h2 { margin: 0; font-size: 20px; line-height: 28px; font-weight: 680; letter-spacing: -.02em; }
.arkme-unmarked-speaker-identity { min-width: 0; display: flex; align-items: center; gap: 16px; padding: 2px 4px; }
.arkme-unmarked-speaker-identity > div { min-width: 0; display: grid; gap: 3px; }
.arkme-unmarked-speaker-identity p { margin: 0; color: var(--dsw-alias-label-secondary, #737984); font-size: 12px; line-height: 18px; }
.arkme-unmarked-speaker-stats {
  min-width: 0; display: flex; flex-wrap: wrap; gap: 8px 20px; padding: 0 4px; color: var(--dsw-alias-label-secondary, #737984);
  font-size: 12px; line-height: 19px;
}
.arkme-unmarked-speaker-stats span { position: relative; white-space: nowrap; }
.arkme-unmarked-speaker-stats span + span::before { content: ""; position: absolute; top: 8px; left: -11px; width: 3px; height: 3px; border-radius: 50%; background: var(--dsw-alias-label-caption, #b3b7bd); }
.arkme-unmarked-speaker-stats strong { color: var(--dsw-alias-label-primary, #202124); font-weight: 650; }
.arkme-unmarked-speaker-inference {
  min-width: 0; display: grid; grid-template-columns: 40px minmax(0, 1fr); align-items: start; gap: 12px; padding: 18px;
  border-radius: 18px; background: var(--dsw-alias-bg-layer-2, #f5f5f6);
}
.arkme-unmarked-speaker-inference-icon, .arkme-unmarked-speaker-action-icon {
  width: 40px; height: 40px; display: grid; place-items: center; border: 1px solid var(--dsw-alias-border-l1, #e3e4e7);
  border-radius: 50%; background: var(--dsw-alias-bg-layer-1, #fff); color: var(--dsw-alias-label-secondary, #656b75);
}
.arkme-unmarked-speaker-inference-icon svg path, .arkme-unmarked-speaker-action-icon svg path { stroke: currentColor; stroke-width: 1.5; stroke-linecap: round; stroke-linejoin: round; }
.arkme-unmarked-speaker-inference > div { min-width: 0; display: grid; gap: 5px; }
.arkme-unmarked-speaker-inference-label { color: var(--dsw-alias-label-secondary, #747983); font-size: 11px; line-height: 16px; }
.arkme-unmarked-speaker-inference strong { color: var(--dsw-alias-label-primary, #202124); font-size: 14px; line-height: 21px; font-weight: 650; }
.arkme-unmarked-speaker-inference p { margin: 0; color: var(--dsw-alias-label-secondary, #686e78); font-size: 12px; line-height: 20px; }
.arkme-unmarked-speaker-actions { display: grid; gap: 10px; }
[data-arkme-workspace] .arkme-unmarked-speaker-action {
  width: 100%; min-height: 62px; display: grid; grid-template-columns: 42px minmax(0, 1fr); align-items: center; gap: 12px;
  padding: 10px 46px 10px 14px; position: relative; border: 1px solid var(--dsw-alias-border-l1, #e5e6e8); border-radius: 16px;
  background: var(--dsw-alias-bg-layer-1, #fff); color: var(--dsw-alias-label-primary, #202124); text-align: left; cursor: pointer; font-size: 13px; font-weight: 650;
}
.arkme-unmarked-speaker-action::after { content: "›"; position: absolute; right: 18px; color: var(--dsw-alias-label-caption, #a7abb2); font-size: 22px; font-weight: 400; }
.arkme-unmarked-speaker-action:hover { background: var(--dsw-alias-interactive-bg-hover, #f7f7f8); border-color: var(--dsw-alias-border-l2, #d9dade); }
.arkme-unmarked-speaker-summary > [role="status"], .arkme-unmarked-speaker-summary > [role="alert"], .arkme-unmarked-speaker-audio > [role="status"], .arkme-unmarked-speaker-audio > [role="alert"], .arkme-unmarked-speaker-choice > [role="status"], .arkme-unmarked-speaker-choice > [role="alert"] { padding: 9px 12px; border-radius: 10px; color: var(--dsw-alias-label-secondary, #68707c); background: var(--dsw-alias-bg-layer-2, #f5f5f6); font-size: 12px; line-height: 18px; }
.arkme-unmarked-speaker-summary > [role="alert"], .arkme-unmarked-speaker-audio > [role="alert"], .arkme-unmarked-speaker-choice > [role="alert"] { color: var(--dsw-alias-state-error-primary, #b42318); background: var(--dsw-alias-state-error-tertiary, #fff1f0); }
.arkme-unmarked-speaker-audio, .arkme-unmarked-speaker-choice {
  width: min(100%, 720px); box-sizing: border-box; display: grid; gap: 16px; margin: 0 auto; padding: 4px 0 28px;
  border: 0; background: transparent;
}
.arkme-unmarked-speaker-subview-header { min-width: 0; display: grid; grid-template-columns: auto 40px minmax(0, 1fr); align-items: center; gap: 12px; padding-bottom: 4px; }
.arkme-unmarked-speaker-subview-header > button { min-height: 32px; padding: 0 10px; border-radius: 9px; color: var(--dsw-alias-label-secondary, #68707c); background: transparent; cursor: pointer; font-size: 11px; }
.arkme-unmarked-speaker-subview-header > button::before { content: "‹"; margin-right: 4px; font-size: 17px; vertical-align: -1px; }
.arkme-unmarked-speaker-subview-heading { min-width: 0; display: grid; gap: 2px; }
.arkme-unmarked-speaker-subview-heading p { margin: 0; color: var(--dsw-alias-label-secondary, #737984); font-size: 11px; line-height: 17px; }
.arkme-unmarked-speaker-segment-list { display: grid; gap: 10px; }
.arkme-unmarked-speaker-segment-card {
  min-width: 0; display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 8px 16px; padding: 16px 16px 14px;
  border: 1px solid var(--dsw-alias-border-l1, #e5e6e8); border-radius: 16px; background: var(--dsw-alias-bg-layer-1, #fff);
}
.arkme-unmarked-speaker-segment-meta { min-width: 0; overflow: hidden; color: var(--dsw-alias-label-secondary, #757b85); font-size: 11px; line-height: 17px; text-overflow: ellipsis; white-space: nowrap; }
.arkme-unmarked-speaker-segment-transcript { grid-column: 1; min-width: 0; margin: 0; color: var(--dsw-alias-label-primary, #292c34); font-size: 13px; line-height: 20px; white-space: pre-wrap; }
[data-arkme-workspace] .arkme-unmarked-speaker-segment-play { display: inline-grid; grid-column: 2; grid-row: 1 / span 2; place-items: center; align-self: center; width: 38px; height: 38px; min-width: 38px; min-height: 38px; padding: 0; border-radius: 50%; background: var(--dsw-alias-bg-layer-2, #f4f4f5); color: var(--dsw-alias-label-primary, #292c34); cursor: pointer; }
[data-arkme-workspace] .arkme-unmarked-speaker-segment-play:not(:disabled):hover { background: var(--dsw-alias-bg-layer-3, #e9eaec); }
.arkme-unmarked-speaker-segment-play:disabled { opacity: .5; cursor: default; }
.arkme-unmarked-speaker-choice-meta { margin: -4px 0 0; padding: 0 4px; color: var(--dsw-alias-label-secondary, #737984); font-size: 12px; line-height: 18px; }
.arkme-unmarked-speaker-choice-options { min-width: 0; display: grid; gap: 8px; margin: 0; padding: 0; border: 0; }
.arkme-unmarked-speaker-choice-options legend { margin-bottom: 9px; color: var(--dsw-alias-label-secondary, #737984); font-size: 11px; line-height: 17px; }
.arkme-unmarked-speaker-choice-option {
  min-width: 0; min-height: 52px; display: grid; grid-template-columns: 18px minmax(0, 1fr) auto; align-items: center; gap: 10px;
  padding: 10px 14px; border: 1px solid var(--dsw-alias-border-l1, #e5e6e8); border-radius: 14px; background: var(--dsw-alias-bg-layer-1, #fff); cursor: pointer; font-size: 13px;
}
.arkme-unmarked-speaker-choice-option:has(input:checked) { border-color: var(--dsw-alias-state-business-primary, #6677d9); background: var(--dsw-alias-interactive-bg-active, #f0f2ff); }
.arkme-unmarked-speaker-choice-option input { width: 16px; height: 16px; margin: 0; accent-color: var(--dsw-alias-state-business-primary, #6677d9); }
.arkme-unmarked-speaker-recommended { padding: 2px 7px; border-radius: 999px; background: var(--dsw-alias-state-business-tertiary, #eef0ff); color: var(--dsw-alias-state-business-primary, #5667cc); font-size: 10px; line-height: 16px; }
.arkme-unmarked-speaker-choice-new-name { width: 100%; min-height: 42px; padding: 0 13px; border: 1px solid var(--dsw-alias-border-l1, #dfe1e5); border-radius: 12px; outline: 0; background: var(--dsw-specific-input-major, #fff); color: var(--dsw-alias-label-primary, #202124); font-size: 12px; }
.arkme-unmarked-speaker-choice-new-name:focus { border-color: var(--dsw-alias-state-business-primary, #6677d9); box-shadow: 0 0 0 3px color-mix(in srgb, var(--dsw-alias-state-business-primary, #6677d9) 14%, transparent); }
[data-arkme-workspace] .arkme-unmarked-speaker-confirm { min-height: 42px; padding: 0 16px; border-radius: 12px; background: var(--dsw-alias-button-primary-fill, #202124); color: var(--dsw-alias-label-primary-inverted, #fff); cursor: pointer; font-size: 12px; font-weight: 650; }
.arkme-unmarked-speaker-confirm:disabled { opacity: .45; cursor: default; }
.arkme-unmarked-speaker-summary button:not(.arkme-unmarked-speaker-action), .arkme-unmarked-speaker-audio button:not(.arkme-unmarked-speaker-segment-play), .arkme-unmarked-speaker-choice button:not(.arkme-unmarked-speaker-confirm), .arkme-contact-world-error button, .arkme-contact-profile-error button {
  min-height: 34px; padding: 0 12px; border: 1px solid var(--dsw-alias-border-l2, var(--arkme-line)); border-radius: 9px;
  background: var(--dsw-alias-button-elevated-fill, #fff); color: var(--dsw-alias-label-primary, #202124); cursor: pointer;
}
.arkme-unmarked-speaker-gone, .arkme-unmarked-speaker-success { width: min(100%, 680px); box-sizing: border-box; margin: 0 auto; padding: 12px 14px; border-radius: 10px; background: var(--dsw-alias-state-warning-tertiary, #fff7ed); color: var(--dsw-alias-state-warning-primary, #9a3412); }
.arkme-unmarked-speaker-success { background: var(--dsw-alias-state-success-tertiary, #ecfdf3); color: var(--dsw-alias-state-success-primary, #067647); }
.arkme-contact-directory button:focus-visible, .arkme-directory-detail-pane button:focus-visible { outline: 2px solid var(--arkme-focus); outline-offset: 2px; }
[data-arkme-owned="product-navigation"] button:focus-visible { outline: 2px solid var(--arkme-focus); outline-offset: 2px; }

body[data-ds-dark-theme] .arkme-contact-directory { --arkme-contact-directory-header-fill: var(--dsw-alias-bg-base); }
body[data-ds-dark-theme] .arkme-contact-directory, body[data-ds-dark-theme] .arkme-directory-detail-pane { background: var(--dsw-alias-bg-base); color: var(--dsw-alias-label-primary); }
body[data-ds-dark-theme] .arkme-contact-directory-row.is-selected, body[data-ds-dark-theme] .arkme-unmarked-speaker-choice { background: var(--dsw-alias-interactive-bg-active); }
body[data-ds-dark-theme] .arkme-unmarked-speaker-inference,
body[data-ds-dark-theme] .arkme-unmarked-speaker-segment-card,
body[data-ds-dark-theme] .arkme-unmarked-speaker-choice-option,
body[data-ds-dark-theme] .arkme-unmarked-speaker-action { background: var(--dsw-alias-bg-layer-1); border-color: var(--dsw-alias-border-l1); }
body[data-ds-dark-theme] .arkme-unmarked-speaker-inference-icon,
body[data-ds-dark-theme] .arkme-unmarked-speaker-action-icon,
body[data-ds-dark-theme] .arkme-unmarked-speaker-segment-play { background: var(--dsw-specific-input-major); color: var(--dsw-alias-label-secondary); }
body[data-ds-dark-theme] .arkme-unmarked-speaker-choice-option:has(input:checked) { background: var(--dsw-alias-interactive-bg-active); border-color: var(--dsw-alias-state-business-primary); }
body[data-ds-dark-theme] .arkme-team-detail { background: var(--dsw-alias-bg-base); }
body[data-ds-dark-theme] .arkme-team-members { background: var(--dsw-alias-bg-subtle); }
body[data-ds-dark-theme] .arkme-team-member-list { background: var(--dsw-alias-bg-layer-1); box-shadow: none; }
body[data-ds-dark-theme] .arkme-contact-directory-warning,
body[data-ds-dark-theme] .arkme-unmarked-speaker-gone,
body[data-ds-dark-theme] .arkme-contact-world-image-error,
body[data-ds-dark-theme] .arkme-contact-world-image-loading { background: var(--dsw-specific-input-major); color: var(--dsw-alias-label-secondary); }
body[data-ds-dark-theme] .arkme-unmarked-speaker-success { background: var(--dsw-alias-state-success-tertiary); color: var(--dsw-alias-state-success-primary); }
body[data-ds-dark-theme] .arkme-contact-profile-error,
body[data-ds-dark-theme] .arkme-contact-profile-message-error,
body[data-ds-dark-theme] .arkme-contact-world-error { color: var(--dsw-alias-state-error-primary); }
body[data-ds-dark-theme] .arkme-contact-directory-more { color: var(--dsw-alias-state-business-primary); }

@media (max-width: 1024px) {
  [data-arkme-owned="persistent-sidebar"] [data-arkme-directory-mode="contacts"] { min-width: 0; }
}
@media (max-width: 820px) {
  /* AppFrame has no public full-width panel action: its closed sidebar still
     reserves 56px. Contacts therefore owns exactly one AppFrame grid seat. */
  div:has(> [data-shell-overlay]):has([data-arkme-directory-mode="contacts"]):has([data-arkme-contacts-mobile-view="directory"]) { grid-template-columns: minmax(0, 1fr) 0px 0px !important; }
  div:has(> [data-shell-overlay]):has([data-arkme-directory-mode="contacts"]):has([data-arkme-contacts-mobile-view="content"]) { grid-template-columns: 0px minmax(0, 1fr) 0px !important; }
  [data-arkme-owned="persistent-sidebar"][data-arkme-contacts-mobile-view="content"] { display: none !important; }
  [data-arkme-owned="persistent-workspace"][data-arkme-contacts-mobile-view="directory"] { display: none !important; }
  [data-arkme-owned="persistent-sidebar"] [data-arkme-directory-mode="contacts"], .arkme-directory-detail-pane { min-width: 0; }
}
.arkme-directory-mobile-back { display: none; }
@media (max-width: 820px) {
  .arkme-directory-mobile-back {
    display: inline-flex; min-height: 42px; align-items: center; gap: 5px; padding: 0 14px;
    background: transparent; color: var(--dsw-alias-label-secondary, #68707c); cursor: pointer;
  }
  .arkme-directory-mobile-back::before { content: "‹"; font-size: 18px; line-height: 1; }
  .arkme-directory-mobile-back:hover { color: var(--dsw-alias-label-primary, #202124); }
  .arkme-contact-detail { padding: 28px 20px; }
  .arkme-contact-profile-main { grid-template-columns: 56px minmax(0, 1fr); gap: 18px; }
  .arkme-contact-profile-avatar { width: 56px; height: 56px; }
  .arkme-contact-profile-avatar > span { width: 56px !important; height: 56px !important; }
  .arkme-team-detail-header { padding: 26px 20px; }
  .arkme-team-detail-header-main { grid-template-columns: 56px minmax(0, 1fr); gap: 12px; }
  .arkme-team-detail-glyph { width: 56px; height: 56px; border-radius: 16px; font-size: 18px; }
  .arkme-team-detail-count { grid-column: 2; min-width: 0; display: flex; justify-items: initial; align-items: baseline; gap: 4px; }
  .arkme-team-detail-count strong { font-size: 14px; line-height: 18px; }
  .arkme-team-detail-count span { font-size: 11px; }
  .arkme-team-members { padding: 18px 20px 28px; }
  .arkme-team-member-list { border-radius: 12px; }
  .arkme-team-member-row { padding-right: 12px; padding-left: 12px; }
  .arkme-contact-world, .arkme-contact-profile-row { grid-template-columns: 64px minmax(0, 1fr); gap: 12px; }
  .arkme-contact-world-thumbnail { width: 44px; height: 44px; }
  .arkme-directory-unmarked-speaker-detail { padding: 20px 18px 30px; }
  .arkme-unmarked-speaker-summary, .arkme-unmarked-speaker-audio, .arkme-unmarked-speaker-choice { gap: 14px; }
  .arkme-unmarked-speaker-stats { gap: 7px 14px; }
  .arkme-unmarked-speaker-stats span + span::before { display: none; }
  .arkme-unmarked-speaker-inference { grid-template-columns: 36px minmax(0, 1fr); padding: 15px; }
  .arkme-unmarked-speaker-inference-icon, .arkme-unmarked-speaker-action-icon { width: 36px; height: 36px; }
  .arkme-unmarked-speaker-subview-header { grid-template-columns: auto 36px minmax(0, 1fr); gap: 9px; }
  .arkme-unmarked-speaker-segment-card { grid-template-columns: minmax(0, 1fr); }
  .arkme-unmarked-speaker-segment-transcript, [data-arkme-workspace] .arkme-unmarked-speaker-segment-play { grid-column: 1; grid-row: auto; }
  [data-arkme-workspace] .arkme-unmarked-speaker-segment-play { justify-self: start; }
}
@media (prefers-reduced-motion: reduce) {
  .arkme-contact-directory-caret { transition: none; }
  .arkme-icon-spin { animation: none; }
}

/* Chat-specific colors follow DSH's single light/dark owner. */
.arkme-conversation-surface {
  --arkme-chat-self-bubble: #eef1f8;
  --arkme-chat-other-bubble: #f3f4f6;
}
body[data-ds-dark-theme] .arkme-conversation-surface {
  --arkme-chat-self-bubble: #2c3142;
  --arkme-chat-other-bubble: #282a31;
  --arkme-audio-control: #8995c5;
}
body[data-ds-dark-theme] .arkme-detail-extension-input-bar {
  border-top-color: #363636 !important;
}
body[data-ds-dark-theme] .arkme-detail-extension-input-shell {
  background: #2b2b2b !important;
}
[data-arkme-message-direction]:focus-visible,
[data-arkme-note-detail] button:focus-visible {
  outline: 2px solid var(--dsw-alias-state-business-primary, #8295e8);
  outline-offset: 2px;
}
.arkme-home-tour { position: absolute; width: 320px; max-width: calc(100vw - 24px); color: var(--dsw-alias-label-primary, #17191c); pointer-events: auto; }
.arkme-home-tour-hidden { display: none; }
.arkme-home-tour-panel { position: relative; box-sizing: border-box; width: 100%; max-height: calc(100dvh - 24px); overflow-y: auto; padding: 18px; border: 1px solid var(--dsw-alias-border-l2, rgba(0,0,0,.1)); border-radius: 16px; background: var(--dsw-alias-bg-base, #fff); box-shadow: var(--dsw-shadow-lv2, 0 12px 40px rgba(0,0,0,.18)); font-family: inherit; }
.arkme-home-tour-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.arkme-home-tour-progress { color: var(--dsw-alias-label-secondary, #68707c); font-size: 12px; line-height: 20px; font-variant-numeric: tabular-nums; }
.arkme-home-tour-panel h2 { margin: 8px 0; color: inherit; font-size: 18px; font-weight: 600; line-height: 26px; }
.arkme-home-tour-panel p { margin: 0 0 24px; color: var(--dsw-alias-label-secondary, #68707c); font-size: 14px; line-height: 22px; overflow-wrap: anywhere; }
.arkme-home-tour-actions, .arkme-home-tour-navigation { display: flex; align-items: center; gap: 8px; }
.arkme-home-tour-actions { justify-content: space-between; flex-wrap: wrap; }
.arkme-home-tour-panel button { padding: 7px 10px; border: 0; border-radius: 8px; background: var(--dsw-alias-interactive-bg-hover, rgba(38,49,72,.06)); color: inherit; font: inherit; font-size: 12px; line-height: 18px; white-space: nowrap; cursor: pointer; }
.arkme-home-tour-panel button:hover { background: var(--dsw-alias-interactive-bg-active, rgba(38,49,72,.1)); }
.arkme-home-tour-panel button:focus-visible { outline: 2px solid var(--dsw-alias-state-business-primary, #8295e8); outline-offset: 3px; }
.arkme-home-tour-panel .arkme-home-tour-close { width: 28px; height: 28px; padding: 0; background: transparent; color: var(--dsw-alias-label-secondary, #68707c); font-size: 22px; }
.arkme-home-tour-panel .arkme-home-tour-skip { padding-left: 0; background: transparent; color: var(--dsw-alias-label-secondary, #68707c); }
.arkme-home-tour-panel .arkme-home-tour-primary { background: var(--dsw-alias-button-primary-fill, #17191c); color: var(--dsw-alias-label-primary-inverted, #fff); }
.arkme-home-tour-panel .arkme-home-tour-primary:hover { background: color-mix(in srgb, var(--dsw-alias-button-primary-fill, #17191c) 88%, var(--dsw-alias-bg-base, #fff)); }
.arkme-home-tour-arrow { position: absolute; width: 12px; height: 12px; z-index: 1; pointer-events: none; }
.arkme-home-tour-arrow::before { content: ''; position: absolute; inset: 0; box-sizing: border-box; transform: rotate(45deg); background: var(--dsw-alias-bg-base, #fff); border: 0 solid var(--dsw-alias-border-l2, rgba(0,0,0,.1)); }
/* The inner half covers the panel seam; only the two outward edges are outlined. */
.arkme-home-tour-placement-right .arkme-home-tour-arrow::before { border-bottom-width: 1px; border-left-width: 1px; }
.arkme-home-tour-placement-left .arkme-home-tour-arrow::before { border-top-width: 1px; border-right-width: 1px; }
.arkme-home-tour-placement-bottom .arkme-home-tour-arrow::before { border-top-width: 1px; border-left-width: 1px; }
.arkme-home-tour-placement-top .arkme-home-tour-arrow::before { border-bottom-width: 1px; border-right-width: 1px; }
.arkme-home-tour-placement-right .arkme-home-tour-arrow { left: 0; transform: translateX(-50%) translateY(-50%); }
.arkme-home-tour-placement-left .arkme-home-tour-arrow { right: 0; transform: translateX(50%) translateY(-50%); }
.arkme-home-tour-placement-bottom .arkme-home-tour-arrow { top: 0; transform: translateX(-50%) translateY(-50%); }
.arkme-home-tour-placement-top .arkme-home-tour-arrow { bottom: 0; transform: translateX(-50%) translateY(50%); }

.arkme-conversation-profile-actions { grid-template-columns: minmax(0, 1fr); }

body[data-ds-dark-theme] .arkme-peer-membership-disc { fill: #171717; stroke: #343434; }

/* Match DSH\'s solid selector footer: shared rules live in conversation-selector-style.ts. */
.arkme-self-topic-sort-option {
  display: flex;
  min-width: 176px;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  white-space: nowrap;
}
.arkme-self-topic-sort-option-title {
  color: var(--dsw-alias-label-primary, #17191c);
  line-height: 20px;
}
.arkme-self-topic-sort-option-description {
  color: var(--dsw-alias-label-secondary, #68707c);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

/* The two retained directories share the same divider and header appearance. */
[data-arkme-owned="persistent-sidebar"] [data-arkme-retained-directory] {
  border-left-color: var(--dsw-alias-border-l1, #ececef) !important;
}

/* Call contact picker search and invitation focus states. */
.arkme-call-picker-search:focus-within {
  --arkme-call-search-border: var(--dsw-alias-label-secondary, #68707c);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--dsw-alias-label-secondary, #68707c) 10%, transparent);
}

.arkme-call-picker-search input::placeholder {
  color: var(--dsw-alias-label-secondary, #68707c);
  opacity: 1;
}

.arkme-call-picker-invite:hover {
  box-shadow: inset 0 0 0 1px var(--dsw-alias-border-l2, rgba(0, 0, 0, .1));
}

.arkme-call-picker-invite:focus-visible {
  outline: 2px solid var(--dsw-alias-label-secondary, #68707c);
  outline-offset: 2px;
}
